import PageCommon from "./../PageCommon.js";
import Pqp from "../../3x1010/Pqp.js";
import Globals from "../../Globals.js";
import { SecurityAcl, SecurityAclContext, AuthCheckAcl } from "../../Security.js";
import Locker from "../../Locker.js";
import { ModalConfirm, ModalAlert } from "../../su/Modals.js";
import ListSelect from "../../su/ListSelect.js";

export default class PageDetail extends PageCommon {
	constructor() {
		super();
		this.templates = {};
		this.doNotReactToFieldChange = false;
		this.formInited = false;
		this.demo = false;
	}
	init($data, lDemo = false) {
		this.demo = lDemo;

		super.init($data);

		this.data = $data;

		this.patch()


		//console.log(this.data);

		this.lck = null;
		this._updated = false;
		this.fattenHtml();

		if (this.demo) {
			this.createCodeScript();
		}
		this.getAndSetFormState();
		console.log(this.viewState.m);

		// creo lock
		this.lck = new Locker(this.data.lockerUri);
		// pre


		this.preInitForm(0);


		// dispaccio un evento globale : errore
		this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);


	}

	patch() {

		//	this.data.row.LinkedObjects = ["0B84M","0B87A"]

	}

	fattenHtml() {
		// Aggiunge in automatico il tag per l'errore
		let sis = jQuery(".single-input");
		for (let x = 0; x < sis.length; x++) {
			let si = jQuery(sis[x]);
			let n = jQuery(".js-error-txt", si);
			if (n.length === 0) {
				let div = jQuery(`<div class="error-txt js-error-txt">&nbsp;</div>`);
				si.append(div);
			}
		}

		// Crea gli input multipli negli input sets simple
		let sets = jQuery(".input-set");
		for (let z = 0; z < sets.length; z++) {
			let sset = jQuery(sets[z]);
			if (sset.data("set-type") === PageDetail.SET_SIMPLE) {
				let area = jQuery(".js-input-area-nls", sset);
				this.createNlsInputs(area)
			}
		}

	}

	createNlsInputs(area) {
		let input = area.children().first();
		input.remove();
		for (let y = 0; y < this.data.locales.length; y++) {
			let inputnls = input.clone();
			area.append(inputnls);
			inputnls.attr("data-fld-locale", this.data.locales[y].Uid);
			if (y > 0) {
				inputnls.hide();
			}
		}
	}



	// *********************************************************
	// m: r c u e (mode)
	get viewState() {
		return this._viewState;
	}

	set viewState(value) {
		this._viewState = value;
		//
		StateManager.setViewState("frm", this.viewState);
	}

	createRowBasicStruct() {
		if (this.data.row === null)
			this.data.row = new Object();

		// Non esiste, crea Translations
		this.data.row.Translations = new Array();
		for (let x = 0; x < this.data.locales.length; x++) {
			this.data.row.Translations.push(this.getSingleTranslationDefault(this.data.locales[x]));
		}

	}

	getSingleTranslationDefault(locale) {
		// Crea un oggetto Translations quando non presente (nella insert)
		let ret = new Object();
		ret.Locale = locale.Value; // Oppure Uid

		return ret;
	}


	// GESTIONE VIEW STATE FORM
	// E CONTROLLO PRELININARE
	getAndSetFormState() {
		this._viewState = { m: PageDetail.STATE_READ } // READ CREATE UPDATE EDIT
		let stat = StateManager.getViewState("frm");
		if (stat) {
			this._viewState = stat;
		}
		if (this.data.row == null || (this.data.row !== null && this.data.row.Uid === "")) {
			this.viewState.m = PageDetail.STATE_CREATE;
		}
		if (this.viewState.m == PageDetail.STATE_CREATE && this.data.row != null && this.data.row.Uid !== "") {
			this.viewState.m = PageDetail.STATE_UPDATE;
		}
		if (this.viewState.m == PageDetail.STATE_UPDATE) {
			if (!this.aclContext.HasGrantedAcl(new AuthCheckAcl(this.data.rowSUid, SecurityAcl.ACL_UPDATE)))
				this.viewState.m = PageDetail.STATE_READ;
		}
		this.doViewStatePersist();
	}


	doViewStatePersist() {
		StateManager.setViewState("frm", this.viewState);
	}

	get updated() {
		return this._updated && (this.viewState.m == PageDetail.STATE_CREATE || this.viewState.m == PageDetail.STATE_UPDATE);
	}
	set updated(value) {
		this._updated = value;
	}
	// *********************************************************
	// *********************************************************

	preInitForm(step) {
		// indipendemente dallo step se non sono in update vado avanti
		if (this.viewState.m != PageDetail.STATE_UPDATE || !this.lck.lockEnabled) {
			this.initForm();
			this.showPreloader(false);
			return;
		}
		// devo riprendere il lock
		if (step == 0) {
			this.lck.renew(this.preInitForm.bind(this, 1));
		} else if (step == 1) {
			if (this.lck.status != "acquired") {
				$(".js-btn-unlock").hide();
				this.lck.dispose();
				this.viewState.m = PageDetail.STATE_READ;
				this.doViewStatePersist();
			} else {
				$(".js-btn-unlock").show();
				$(".jsBtnUnlock").on("click", this.onPageUnlock.bind(this))
				// starto il thread di renew
				this.lck.startRenewThread(this.onFormLockHandler.bind(this, "renewpoll"));
			}
			this.initForm();
			this.showPreloader(false);
		}
	}

	initForm() {

		//jQuery(".tab-container-details").css("opacity", 1);
		jQuery(".to-show-after-loading").css("opacity", 1);

		this.initFormActions();
		// Sarà giusto? Creo la struttura basica della row
		if (this.data.row == null || (this.data.row !== null && this.data.row.Uid === "")) {
			this.createRowBasicStruct()
		}
		this._setFormFields(true, true, true);  // read, create, update
		this.formInited = true;

		this.onFieldChangeValue(null);



		//
		window.onbeforeunload = this.onPageAbandon.bind(this, true);
		window.onunload = this.onPageAbandon.bind(this, false);
	}

	initFormActions() {
		$(".buttonFormAction").off("click");
		//
		if ((this.data.row == null || (this.data.row !== null && this.data.row.Uid === "")) && this.viewState.m == PageDetail.STATE_CREATE && this.aclContext.HasGrantedAcl(new AuthCheckAcl(this.data.tableSUid, SecurityAcl.ACL_CREATE))) {
			$(".buttonFormAction").text("Aggiungi");
			$(".buttonFormAction").on("click", this.onFormCreate.bind(this));
			$(".buttonFormAction").show();
			PageCommon.disable($(".buttonFormAction"), !this.updated);
		}
		else if (this.data.row != null && this.viewState.m == PageDetail.STATE_UPDATE && this.aclContext.HasGrantedAcl(new AuthCheckAcl(this.data.rowSUid, SecurityAcl.ACL_UPDATE))) {
			$(".buttonFormAction").text("Salva");
			$(".buttonFormAction").on("click", this.onFormSave.bind(this));
			$(".buttonFormAction").show();
			PageCommon.disable($(".buttonFormAction"), !this.updated);
		}
		else if (this.data.row != null && this.aclContext.HasGrantedAcl(new AuthCheckAcl(this.data.rowSUid, SecurityAcl.ACL_READ))) {
			this.viewState.m == PageDetail.STATE_READ;
			this.doViewStatePersist();
			//
			if (this.aclContext.HasGrantedAcl(new AuthCheckAcl(this.data.rowSUid, SecurityAcl.ACL_UPDATE))) {
				$(".buttonFormAction").text("Modifica");
				$(".buttonFormAction").on("click", this.onFormEdit.bind(this));
				$(".buttonFormAction").show();
				PageCommon.disable($(".buttonFormAction"), false);
			} else {
				$(".buttonFormAction").hide();
			}
		}
		else {
			this.viewState.m == PageDetail.STATE_ERROR; // error
			this.doViewStatePersist();
			document.location.href = TheApp.Env.BaseUrlNls + "deny";
		}
		// per sicurezza dispongo il lock
		if (this.viewState.m != PageDetail.STATE_UPDATE)
			this.lck.dispose();
	}

	onFormCreate() {
		if (!this.updated)
			return;
		// collect data
		let data = $.extend({}, this.data.row);
		let result = this._getFormFields(data, true);


		//console.log("-------------------------")
		//console.log(result)
		//console.log(data)
		//console.log("-------------------------")

		// return { Success: false, Message: "Form error" };
		if (!result.Success) {
			let modal = new ModalAlert($("#template-modalAlert"));
			modal.create(
				{
					title: "ERRORE",
					body: result.Message,
					close: "CHIUDI",
					error: true
				});
			modal.init();
			return;
		}

		//return

		// a questo punto chiamo il servizio
		// serviceRoute
		this.showPreloader(true);
		let rq = {
			Value: null,
			ContentLocale: TheApp.ContentLocale,
			Data: data
		}
		thatServiceManeger.standardCall(this.data.serviceCreateRoute, rq, this.onFormSaveHandler.bind(this, "CREATE"));
	}

	onFormSave() {
		if (!this.updated)
			return;
		// collect data
		let data = $.extend({}, this.data.row);
		let result = this._getFormFields(data, true);


		//console.log("-------------------------")
		//console.log(result)
		//console.log(data)
		////this.datona = data;
		//console.log("-------------------------")


		// return { Success: false, Message: "Form error" };
		if (!result.Success) {
			let modal = new ModalAlert($("#template-modalAlert"));
			modal.create(
				{
					title: "ERRORE",
					body: result.Message,
					close: "CHIUDI",
					error: true
				});
			modal.init();
			return;
		}

		//return // DA TOGLIERE

		// a questo punto chiamo il servizio
		// serviceRoute
		this.showPreloader(true);
		let rq = {
			Value: data.Uid,
			ContentLocale: TheApp.ContentLocale,
			Data: data
		}
		thatServiceManeger.standardCall(this.data.serviceUpdateRoute, rq, this.onFormSaveHandler.bind(this, "UPDATE"));
	}

	reloadPage(split) {
		document.location.href = StateManager._mergeUrl(split);
	}

	gotoPage(nextPage) {
		document.location.href = nextPage;
	}

	onFormSaveHandler(verb, rs) {
		if (rs && rs.Success) {
			if (verb == "CREATE") {
				this.viewState.m = PageDetail.STATE_UPDATE;
				this.updated = false;
				this.doViewStatePersist();
				let split = StateManager._splitUrl(document.location.href);
				split.url += (split.url.endsWith("/") ? "" : "/") + Base64.toBase64(rs.Data.Uid, true);
				//document.location.href = StateManager._mergeUrl(split);

				if (this.data.hasOwnProperty('pageCreateResult')) {
					this.showPreloader(false);
					toastr.success("Il record è stato inserito!");
					setTimeout(this.gotoPage.bind(this, this.data.pageCreateResult), 500);
					return;
					//let modal = new ModalAlert($("#template-modalAlert"));
					//modal.create(
					//	{
					//		title: "",
					//		body: "Il record è stato inserito!",
					//		close: "CHIUDI"
					//	}, this.gotoPage.bind(this, this.data.pageCreateResult));
					//modal.init();
					// document.location.href = this.data.pageCreateResult;
					return;
				} else {
					this.showPreloader(false);
					toastr.success("Il record è stato inserito!");
					setTimeout(this.reloadPage.bind(this, split), 500);
					return;
					//let modal = new ModalAlert($("#template-modalAlert"));
					//modal.create(
					//	{
					//		title: "",
					//		body: "Il record è stato inserito!",
					//		close: "CHIUDI"
					//	}, this.reloadPage.bind(this, split));
					//modal.init();
					//return;
                }
			}
			this.showPreloader(false);
			this.data.row = rs.Data;
			//debugger
			//this.datona.Date[0].Translations[0].DescriptionBefore = "TEST"
			//this.data.row = this.datona;
			// this.removeNewTag(); // Da capire con Manca se è necessario, io credo di no (per gestire  il caso dei blocchi nuovi con campi readonly solo in edit)
			this._setFormFields(false, false, true);
			this.onFieldChangeValue(false);
			this.onFormSavedAction(this.data.row);

			//let modal = new ModalAlert($("#template-modalAlert"));
			//modal.create(
			//	{
			//		title: "",
			//		body: "Il record è stato aggiornato!",
			//		close: "CHIUDI"
			//	});
			//modal.init();
			toastr.success("Il record è stato aggiornato!");
			if (this.data.hasOwnProperty('pageUpdateResult')) {
				document.location.href = this.data.pageCreateResult;
				return;
			}
		} else {
			this.showPreloader(false);
			let message = this.handleErrors(rs);
			this.handleFieldsErrors(rs);
			toastr.error(message);
			//let modal = new ModalAlert($("#template-modalAlert"));
			//modal.create(
			//	{
			//		title: "ERRORE",
			//		body: message,
			//		close: "CHIUDI",
			//		error: true
			//	});
			//modal.init();

		}
	}
	removeNewTag() {
		jQuery('*[data-fld-new="true"]').attr("data-fld-new", "false");
	}
	onFormSavedAction(data) {
		//console.log("Action after save");
	}
	handleFieldsErrors(rs) {
		// Mostra l'errore ritornato dal server relativamente ad un campo
		let a = rs.Errors
		if (!a) {
			return;
		}
		for (let x = 0; x < a.length; x++) {
			// (esempio di accesso diretto ad un campo nella form)
			//debugger
			if (!Pqp.isNullOrEmpty(a[x].Field)) {
				let singleInput = this.getSingleInputByName(a[x].Field);
				let error = jQuery(".js-error-txt", singleInput.sinput);
				error.text(this.getFieldErrorReturnedByServer(rs, a[x].Code));
				singleInput.sinput.addClass("has-error");
				jQuery(".js-error-txt", singleInput.sinput).css("opacity", 1);
            }
		}
	}



	onFormEdit() {
		this.showPreloader(true);
		// passa in edit mode facendo prima una richiesta al server 
		this.lck.acquire(this.onFormLockHandler.bind(this, "acquire"));
	}
	// sono passato in edit
	onFormEdit_confirmed(recordStatus = null) {
		this.viewState.m = PageDetail.STATE_UPDATE;
		this.doViewStatePersist();
		//
		this.initFormActions();
		this._setFormFields(false, true, false);
		this.onFieldChangeValue(null);
		if (recordStatus != null) {
			// CAMBIARE IL VALORE NELLA SELECT DI STATUS
			// (esempio di accesso diretto ad un campo nella form)
			//debugger
			let sinput = this.getSingleInputByName("Status"); // questa funzione potrebbe ritornare un array ma per semplicità se ha un solo elemento, lo ritorna senza array
			let select = this.getInput(sinput);
			//console.log("--------------------->" + recordStatus)
			this.doNotReactToFieldChange = true;
			this.setInputValue(select, recordStatus, sinput)
			//select.val(recordStatus);
		}

	}
	// ho perso il lock
	onFormLock_loosed() {
		this.viewState.m = PageDetail.STATE_READ;
		this.doViewStatePersist();
		//
		this.initFormActions();
		this._setFormFields(false, true, false);
		this.onFieldChangeValue(null);
	}

	onFormLockHandler(op, lockStatus, lockData, recordStatus = null) {
		// passo da readonly in edit
		$(".js-btn-unlock").hide();
		if (op == "acquire") {
			this.showPreloader(false);
			//
			if (lockStatus == "acquired") {
				$(".js-btn-unlock").show();
				$(".jsBtnUnlock").on("click", this.onPageUnlock.bind(this))
				// passo in modalita edit
				this.onFormEdit_confirmed(recordStatus);
				// starto il thread di renew
				this.lck.startRenewThread(this.onFormLockHandler.bind(this, "renewpoll"));
			} else if (lockStatus == "denied") {
				let message = "Il record non può essere bloccato.";
				if (lockData && lockData.lck) {
					if (lockData.lck.user_name != TheApp.CurrentContext.userSession.UserName)
						message = "Il record è bloccato dall'utente: " + lockData.lck.user_name;
					else
						message = "Il record è bloccato da te in un'altra sessione.";
				}
				let modal = new ModalAlert($("#template-modalAlert"));
				modal.create(
					{
						title: "FAIL",
						body: message,
						close: "CHIUDI",
						error: true
					});
				modal.init();
			}
			return;
		}
		// renew poll
		if (op == "renewpoll") {
			if (lockStatus == "loosed") {
				this.onFormLock_loosed();
				let modal = new ModalAlert($("#template-modalAlert"));
				modal.create(
					{
						title: "WARNING",
						body: "Il lock è stato rimosso.",
						close: "CHIUDI"
					});
				modal.init();
			}
		}
	}

	onFieldChangeValue(bUpdated) {


		if (!this.formInited) {
			return;
		}


		if (this.doNotReactToFieldChange) {
			this.doNotReactToFieldChange = false;
			return
		}

		if (bUpdated != null) {
			//debugger;
			this.updated = bUpdated;
		}
		if (this.viewState.m == PageDetail.STATE_CREATE || this.viewState.m == PageDetail.STATE_UPDATE) {
			PageCommon.disable($(".buttonFormAction"), !this.updated);
		}
	}

	onPageAbandon(before) {
		if (this.lck)
			this.lck.dispose();
		//
		if (before) {
			if (!this.updated)
				return;
			let confirmationMessage = "Do you really want to leave the page?";
			return confirmationMessage;
		} else {
			//if (this.lck && this.lck.status == "acquired") {
			//	this.lck.release(true, 2000, null);
			//}
		}
	}

	onPageUnlock() {
		if (this.lck)
			this.lck.dispose();
		//
		if (this.lck && this.lck.status == "acquired") {
			this.lck.release(true, this.onPageUnlockHandler.bind(this), 0);
		} else {
			$(".js-menu-edit").removeClass("active");
			$(".js-toggle-btn").removeClass("active");
			$(".js-btn-unlock").hide();
		}
	}

	onPageUnlockHandler(op, lockStatus, lockData, recordStatus = null) {
		this.onFormLock_loosed();
		$(".js-menu-edit").removeClass("active");
		$(".js-toggle-btn").removeClass("active");
		$(".js-btn-unlock").hide();
	}

	getSingleInputByNameInAComplexSetNamed(name, setName) {
		let ret = new Array();
		let sets = this.getInputSets();

		for (let x = 0; x < sets.length; x++) {
			if (sets[x].name === setName) {
				let entries = jQuery(".js-single-block", sets[x].iset);
				for (let y = 0; y < entries.length; y++) {
					let block = jQuery(entries[y])
					let singleInput = this.getSingleInputByName(name, sets[x], block)
					ret.push(singleInput);
				}
			}
		}
		//console.log(ret)
		if (this.demo) {
			//ret.shift();
		}

		return ret;
	}


	getSingleInputByName(name, sset = null, block = null) {
		let ret = new Array();
		// debugger
		/*if (name === "UidRegion") {
			debugger
		}*/

		let sets = this.getInputSets();
		for (let x = 0; x < sets.length; x++) {
			if ((block) && (sets[x].type === PageDetail.SET_COMPLEX) && (sset !== null)) {
				let lCheck = true;
				if (sset) {
					if (sset.iset.html() !== sets[x].iset.html()) {
						lCheck = false;
					}
				}
				if (lCheck) {
					let clips = jQuery(".single-input", block);
					for (let x = 0; x < clips.length; x++) {
						let singleInput = this.getSingleInputOfABlock(jQuery(clips[x]), sset, block);
						if (singleInput.name === name) {
							ret.push(singleInput);
						}
					}
				}
			} else if ((sets[x].type === PageDetail.SET_COMPLEX) && (sset !== null)) {
				let lCheck = true;
				if (sset) {
					if (sset.iset.html() !== sets[x].iset.html()) {
						lCheck = false;
					}
				}
				if (lCheck) {
					let blocks = jQuery(".js-single-block", sets[x].iset);
					for (let y = 0; y < blocks.length; y++) {
						let block = jQuery(blocks[y]);
						let clips = jQuery(".single-input", block);
						for (let x = 0; x < clips.length; x++) {
							let singleInput = this.getSingleInputOfABlock(jQuery(clips[x]), sset, block);
							if (singleInput.name === name) {
								ret.push(singleInput);
							}
						}
					}
				}


			} else {
				if (sets[x].type === PageDetail.SET_SIMPLE) {
					let singleInput = this.getSingleInput(sets[x].iset);
					if (singleInput.name === name) {
						ret.push(singleInput);
					}
				}
			}
		}
		if (ret.length === 1) {
			return ret[0];
		}
		return ret;
	}



	toB(value) {
		if ("" + value === "true") {
			return true;
		}
		return false;
	}
	toS(value) {
		if ((Pqp.isNullOrEmpty(value)) && ("" + value != 0)) {
			return null;
		}
		return value;
	}
	/*toSorA(value) {
		if ((Pqp.isNullOrEmpty(value)) && ("" + value != 0)) {
			return null;
		}
		return value;
	}*/
	toN(value) {
		if (Pqp.isNullOrEmpty(value)) {
			return -1;
		}
		let n = parseInt(value);
		if (isNaN(n)) {
			return -1;
		}

		return n;
	}

	toNumeric(value) {
		if (Pqp.isNullOrEmpty(value)) {
			return "dummy";
		}
		let n = parseInt(value);
		if (isNaN(n)) {
			return "dummy";
		}
		return n;
	}


	toFloat(value) {
		if (Pqp.isNullOrEmpty(value)) {
			return "dummy";
		}
		let n = parseFloat(value);
		if (isNaN(n)) {
			return "dummy";
		}
		return n;
	}


	getInput(singleInput) {

		if (!singleInput.isnls) {
			// Campi semplici non in lingua
			if (singleInput.type === PageDetail.TYPE_INPUT) {
				return jQuery("input", singleInput.sinput);
			}
			if (singleInput.type === PageDetail.TYPE_INPUT_EMAIL) {
				return jQuery("input", singleInput.sinput);
			}
			if (singleInput.type === PageDetail.TYPE_INPUT_NUMERIC) {
				return jQuery("input", singleInput.sinput);
			}
			if (singleInput.type === PageDetail.TYPE_INPUT_FLOAT) {
				return jQuery("input", singleInput.sinput);
			}
			if (singleInput.type === PageDetail.TYPE_TEXTAREA) {
				return jQuery("textarea", singleInput.sinput);
			}
			if (singleInput.type === PageDetail.TYPE_SELECT) {
				return jQuery("select", singleInput.sinput);
			}
			if (singleInput.type === PageDetail.TYPE_UPLOAD) {
				return jQuery("input", singleInput.sinput);
			}
			if (singleInput.type === PageDetail.TYPE_LIST) {
				return jQuery("input", singleInput.sinput);
			}
			if (singleInput.type === PageDetail.TYPE_CHECKBOX) {
				return jQuery("input", singleInput.sinput);
			}
		} else {
			// Campi in lingua (array di risultati)
			if (singleInput.type === PageDetail.TYPE_NLSINPUT) {
				let ret = new Array();
				let a = jQuery("input", singleInput.sinput);
				for (let x = 0; x < a.length; x++) {
					ret.push(jQuery(a[x]));
				}
				return ret;
			}
			if (singleInput.type === PageDetail.TYPE_NLSTEXTAREA) {
				let ret = new Array();
				let a = jQuery("textarea", singleInput.sinput);
				for (let x = 0; x < a.length; x++) {
					ret.push(jQuery(a[x]));
				}
				return ret;
			}

		}
		if (!this.demo) {
			alert("Attenzione! Tipologia di singleinput non trovata: " + singleInput.type);
		}
		return null;
	}



	initSelect2(singleInput) {
		// Trasforma la selec2 semplice in select2 (multipla o semplice a seconda del parametro)
		//		if (Pqp.isNullOrEmpty(singleInput.provider)) {
		if (singleInput.type !== PageDetail.TYPE_SELECT) {
			return;
		}
		let select = this.getInput(singleInput);
		if (Pqp.isNullOrEmpty(singleInput.selectTemplate)) {
			select.select2();
		} else {
			select.select2({
				templateSelection: this[singleInput.selectTemplate].bind(this, singleInput),
				templateResult: this[singleInput.selectTemplate].bind(this, singleInput)
			});
		}
		if (!Pqp.isNullOrEmpty(singleInput.fillsSelect)) {
			// Se al change deve fillare un'altra select, aggiunge l'evento
			select.off("change.sel2");
			select.on("change.sel2", this.fillDependencySelect.bind(this, singleInput));
		}
		// Controlla se il singleinput fa parte di un gruppo complex e se il suo provider corrisponde a quello del gruppo complex
		if (singleInput.complex) {
			if (singleInput.sset.blocksMaxFromProvider) {
				if (singleInput.sset.blocksMaxFromProvider === singleInput.provider) {
					select.off("change.sel3");
					select.on("change.sel3", this.updateFillSetSelects.bind(this, singleInput));
				}
			}
		}

	}

	updateFillSetSelects(singleInput) {
		// Becca tutte le select di un determinato provider di un set e le filla rimuovendo gli elementi usati dalle altre select
		if (!singleInput.complex) {
			return
		}
		if (!singleInput.sset.blocksMaxFromProvider) {
			return
		}

		let sto = this.getSingleInputByNameInAComplexSetNamed(singleInput.name, singleInput.sset.name);
		let oldValues = new Array();
		for (let x = 0; x < sto.length; x++) {
			let curSel = this.getInputValue(this.getInput(sto[x]), sto[x]);
			this.fillSelectFromProvider(sto[x]);
			this.getInput(sto[x]).val(curSel);
			oldValues.push(curSel)
		}


		let used = this.getAlreadyUsedValuesInSelects(singleInput);
		let originals = this.fillSelectFromProvider({ type: PageDetail.TYPE_SELECT, provider: singleInput.sset.blocksMaxFromProvider, justCount: true });
		let purged = new Array();
		for (let x = 0; x < originals.length; x++) {
			if (used.indexOf(originals[x]) < 0) {
				purged.push(originals[x]);
			}
		}
		sto = this.getSingleInputByNameInAComplexSetNamed(singleInput.name, singleInput.sset.name);
		for (let x = 0; x < sto.length; x++) {
			let value = this.getInputValue(this.getInput(sto[x]), sto[x]);
			let values = purged.slice();
			if (!Pqp.isNullOrEmpty(value)) {
				values.push(value);
			}
			let select = this.getInput(sto[x]);
			// Controlla e rimuove le options
			let opts = jQuery("option", select);
			for (let y = 0; y < opts.length; y++) {
				let opt = jQuery(opts[y]);
				if (opt.val() !== "") {
					if (values.indexOf(opt.val()) < 0) {
						opt.remove();
					}
				}
			}
			if (Pqp.isNullOrEmpty(oldValues[x])) {
				this.getInput(sto[x]).val(null);
			}
		}
	}

	getAlreadyUsedValuesInSelects(singleInput) {
		if (!singleInput.complex) {
			return [];
		}
		let sto = this.getSingleInputByNameInAComplexSetNamed(singleInput.name, singleInput.sset.name);
		let used = new Array();
		for (let x = 0; x < sto.length; x++) {
			let value = this.getInputValue(this.getInput(sto[x]), sto[x]);
			if (!Pqp.isNullOrEmpty(value)) {
				used.push(value);
			}
		}
		return used;
	}


	initList(singleInput) {
		if (singleInput.type === PageDetail.TYPE_LIST) {
			jQuery(".list-template", singleInput.sinput).hide();
			let btnAdd = jQuery(".js-add-entry", singleInput.sinput);
			btnAdd.on("click", this.addListEntry.bind(this, singleInput.block, singleInput.sset, singleInput.name));
		}
	}

	addListEntry(block, sset, name) {
		let singleInput = this.getSingleInputByName(name, sset, block);
		let max = -1;
		let value = this.getInputValue(null, singleInput)
		if (singleInput.listItemMax !== -1) {
			max = singleInput.listItemMax - value.length;
		}

		let entries = this.getInputValue(null, singleInput)
		entries.push(this.data.row.Uid)
		let options = {
			title: "Select " + singleInput.listLabel,
			provider: TheProviders[singleInput.provider],
			entries: entries,
			removeDiacritics: singleInput.removeDiacritics,
			handler: this.listSelectEventsHandler.bind(this),
			payload: { singleInput: singleInput },
			multiple: singleInput.listMultiple,
			max: max
		}

		let listSelect = new ListSelect(options);
		listSelect.init();

	}

	listSelectEventsHandler(e) {
		if (e.type === ListSelect.EVENT_SELECTED) {
			let value = this.getInputValue(null, e.payload.singleInput)
			for (let x = 0; x < e.data.length; x++) {
				value.push(e.data[x].Value);
			}
			this.setInputValue(null, value, e.payload.singleInput);
			this.onFieldChangeValue(true);
			this.onFieldChanged(e.payload.singleInput)

		}

	}


	fillDependencySelect(singleInput) {
		// Trova la select da fillare/refreshare e la filla
		//debugger
		let singleInputToFill = this.getSingleInputByName(singleInput.fillsSelect, singleInput.sset, singleInput.block);

		this.fillSelectFromProvider(singleInputToFill)
	}

	fillSelectFromProvider(singleInput) {
		// Riempie la select di un singleinput se questo ha associato un provider
		//if (Pqp.isNullOrEmpty(singleInput.provider)) {
		if (singleInput.type !== PageDetail.TYPE_SELECT) {
			return;
		}

		let select = this.getInput(singleInput);

		// Controlla se è una dipendenza
		let filterValue;
		if (!Pqp.isNullOrEmpty(singleInput.dependency)) {
			// Se è una dipendenza recupera il valore della select da cui dipende
			let singleInputDep = this.getSingleInputByName(singleInput.dependency, singleInput.sset, singleInput.block);
			let selectDep = this.getInput(singleInputDep);
			filterValue = this.getInputValue(selectDep, singleInputDep);
		}

		// riga vuota se non è obbligatorio
		if (!singleInput.justCount) {
			jQuery("option", select).remove(); // Per sicurezza rimuove le options 
			if ((!singleInput.realMandatory)) {// && (this.viewState.m != PageDetail.STATE_READ)) {
				select.append(jQuery("<option value=''></option>"));
			}
		}
		let provider = TheProviders[singleInput.provider];

		// Sto pezzo profuma ma non saprei come farlo altrimenti 
		if (singleInput.provider === "_c_lookup_status") {
			// Se si sta creando il record o se si è già in update
			if (this.viewState.m === PageDetail.STATE_CREATE || this.viewState.m === PageDetail.STATE_UPDATE) {
				// Controlla l'acl
				if (!this.aclContext.HasGrantedAcl(new AuthCheckAcl(this.data.rowSUid, SecurityAcl.ACL_APPROVED))) {
					// In questo caso non ho i diritti di settare l'approved, lo rimuove dal provider
					let tmp = new Array();
					for (let x = 0; x < provider.length; x++) {
						if (provider[x].Value !== "9") {//Common.ACL_APPROVED)
							tmp.push(provider[x])
						}
					}
					provider = tmp;
				}
			}
		}

		let filledIn = 0;
		let inserted = new Array();
		for (let r of provider) {
			let opt = jQuery("<option></option>");
			let ok = true;
			if (!Pqp.isNullOrEmpty(singleInput.dependency)) { // Controlla se la matcha il valore della select da cui dipende
				if (!r.Value.startsWith(filterValue)) {
					ok = false;
				}
			}
			if (ok) {
				if (this.filterOption(singleInput, this.data.row, r)) { // Eventuale filtro custom
					opt.text(r.Label);
					opt.val(r.Value);
					if (!singleInput.justCount) {
						select.append(opt);
					}
					inserted.push(r.Value)
					filledIn++;
				}
			}
		}
		if ((singleInput.realMandatory)) {// && (this.viewState.m != PageDetail.STATE_READ)) {
			select.val(null);
		}


		if (!Pqp.isNullOrEmpty(singleInput.fillsSelect)) {
			// Se un'altra select dipende dalla select appena rifillata, distpatcha l'evento
			select.trigger("change")
		}

		// Uhm qui c'è un po' di profumino, poi vediamo di trovare un modo migliore
		if (!Pqp.isNullOrEmpty(singleInput.dependency)) {
			// Se la select appena fillata dipende da un'altra e se non ci sono risultati allora la disabilita
			if (filledIn === 0) {
				this.setReadOnly(singleInput, true)
			} else {
				// Se non era già readonly per altri motivi, lo sblocca
				if (!singleInput.readonly) {
					this.setReadOnly(singleInput, false)
				}
			}
		}

		/*if (!singleInput.justCount) {
			this.updateFillSetSelects(singleInput)
		}*/

		return inserted;
	}


	initNlsSwitcher(singleInput) {
		// Se è uno switcher, lo inizializza
		if (!singleInput.isnls) {
			return
		}
		let switcher = jQuery(".js-nls-switcher", singleInput.sinput);
		this.enableSwitcher(singleInput, switcher);

	}

	initNlsInfo(singleInput) {
		// Crea la riga delle lingue completate
		if (!singleInput.isnls) {
			return
		}
		let bar = jQuery(".js-nls-completion", singleInput.sinput);
		let item = jQuery("div", bar);
		item.remove();
		for (let x = 0; x < this.data.locales.length; x++) {
			let lng = item.clone();
			lng.text(this.data.locales[x].Label.toLowerCase());
			lng.addClass("nls-completion-item-" + this.data.locales[x].Uid) // Or value??
			bar.append(lng);
		}


	}

	enableSwitcher(singleInput, switcher) {
		// Inizializza lo switcher per gli input in lingua
		switcher.show();
		switcher.shieldDropDown({
			dataSource: {
				data: this.data.locales,
			},
			events: {
				select: this.onChangedSwitcher.bind(this, singleInput)
			},
			selected: 0,
			textTemplate: "{Label}",
			valueTemplate: "{Value}"
		});
	}

	onChangedSwitcher(singleInput, e) {
		// Quando si cambia la selezione dello switcher viene mostrato l'input corrispondente
		let selectedLocale = e.value;
		let inputs = this.getInput(singleInput);
		for (let x = 0; x < inputs.length; x++) {
			let locale = inputs[x].data("fld-locale");
			if (locale === selectedLocale) {
				inputs[x].show();
			} else {
				inputs[x].hide();
			}
		}
	}


	initUpload(singleInput) {
		if (singleInput.type === PageDetail.TYPE_UPLOAD) {
			let input = this.getInput(singleInput);
			input.attr("type", "hidden");
			input.addClass("js-upload-value");
			let btn = jQuery('<input type="button" class="upload-button js-upload-trigger"/>');
			btn.attr("value", singleInput.uploadCaption);
			input.parent().append(btn);
			// Thumb
			let img = jQuery('<div class="upload-image js-upload-image"></div>');
			img.css("background-position", "center");
			img.css("background-size", "contain");
			img.css("background-repeat", "no-repeat");
			input.parent().append(img);
			this.setUploadThumb(img, singleInput);

			let clear = jQuery('<input type="button" class="upload-clear js-upload-clear"/>');
			clear.attr("value", singleInput.resetCaption);
			clear.hide();


			input.parent().append(clear);

			let a = jQuery('<a href="#" target="_blank" class="upload-link js-upload-link">');
			input.parent().append(a);


			clear.on("click", this.resetUpload.bind(this, singleInput, clear, img, a, input));

			window[singleInput.uploadRules].UplFilterExtensions = Pqp.safeReplace(window[singleInput.uploadRules].UplFilterExtensions, " ", "");

			var uplObject = new TrixUloaderObject(new TrixUloaderParams(window[singleInput.uploadRules]), btn);
			uplObject.init(this.uploadMapHandler.bind(this, uplObject));
		}

	}

	setUploadThumb(img, singleInput) {
		//if (this.isUploadImage(singleInput)) {
		let dims = this.getImageDimensions(singleInput, true);
		if (dims.w === 0) {
			dims.w = 128;
			dims.h = 128;
		}
		if (singleInput.thumbw > 0) {
			dims.w = singleInput.thumbw;
		}
		if (singleInput.thumbh > 0) {
			dims.h = singleInput.thumbh;
		}
		let caption = window[singleInput.uploadRules].UplFilterExtensions;
		if (!Pqp.isNullOrEmpty(singleInput.thumbCaption)) {
			caption = singleInput.thumbCaption;
		}
		img.css("width", dims.w)
		img.css("height", dims.h);
		let url = "https://dummyimage.com/" + dims.w + "x" + dims.h + "/c4c0c4/000000.png&text=" + Pqp.safeReplace(caption, " ", "");
		img.css("background-image", "url(" + url + ")");


		/*
	
			img.css("width", dims.w)
			img.css("height", dims.h);
			img.css("background-image", "url(https://dummyimage.com/" + dims.w + "x" + dims.h + "/c4c0c4/000000.png&text=" + window[singleInput.uploadRules].UplFilterExtensions + ")");
		} else {
			let dims = this.getImageDimensions(singleInput, true);
			if (dims.w === 0) {
				dims.w = 128;
				dims.h = 128;
			}
			img.css("width", dims.w)
			img.css("height", dims.h);
			img.css("background-image", "url(https://dummyimage.com/" + dims.w + "x" + dims.h + "/c4c0c4/000000.png&text=" + window[singleInput.uploadRules].UplFilterExtensions + ")");
		}*/

	}

	resetUpload(singleInput, clear, img, a, input) {
		clear.hide();
		this.setUploadThumb(img, singleInput);
		a.text("");
		a.attr("href", "");
		input.val("");
		this.onFieldChangeValue(true);

	}

	isUploadImage(singleInput) {
		// mmmh profuma
		let ext = window[singleInput.uploadRules].UplFilterExtensions.toLowerCase();
		if ((ext.indexOf("jpg") >= 0) || (ext.indexOf("png") >= 0) || (ext.indexOf("jpeg") >= 0) || (ext.indexOf("gif") >= 0) || (ext.indexOf("bmp") >= 0)) {
			return true;
		}
		return false;
	}

	getImageDimensions(singleInput, lThumb) {
		let ret = { w: 0, h: 0 };
		try {
			let dims
			if (lThumb) {
				dims = window[singleInput.uploadRules].UplThumbs.split(",");
			} else {
				dims = window[singleInput.uploadRules].UplImageResample.split(",");
			}
			for (let x = 0; x < dims.length; x++) {
				if (dims[x].startsWith("s=")) {
					let tmp = dims[x].split("=")[1].split("x");
					ret = { w: parseInt(tmp[0]), h: parseInt(tmp[1]) };
					break;
				}
			}
		} catch (e) {
		}
		return ret;
	}


	uploadMapHandler(uplObject, ev) {
		// container
		let mcContainer = uplObject.params.mcTriggerButton.parent();
		if (ev.type == "start") {
			//this.setUiError(null);
			//CMS.Common.showLoading(true, "0%");
			this.showPreloader(true, "0%");
		}
		else if (ev.type == "progress") {
			this.showPreloader(true, (ev.data.TotalPercent) + "%");
		}
		else if (ev.type == "error") {
			//this.setUiError(ev.data);
			this.showPreloader(false);
			//$(".js-uploadMapLink", mcContainer).text("Errore " + ev.data.Mex);
			let modal = new ModalAlert($("#template-modalAlert"));
			modal.create(
				{
					title: "ERRORE",
					body: "Error " + ev.data.Mex,
					close: "CHIUDI"
				});
			modal.init();
		}
		else if (ev.type == "complete") {
			this.showPreloader(false);
			// this.setValue(ev.data.Files[0].Url);
			//console.log(ev.data.Files[0]);
			$(".js-upload-link", mcContainer).text(ev.data.Files[0].OriFileName);
			$(".js-upload-link", mcContainer).attr("href", ev.data.Files[0].Url);
			$(".js-upload-value", mcContainer).val(ev.data.Files[0].Url);
			$(".js-upload-clear", mcContainer).show();
			// Mostra il thumb
			let thumb = ev.data.Files[0].Url + ".thumb.jpg";
			$(".js-upload-image", mcContainer).css("background-image", "url(" + thumb + ")");


			// se sono in edit ma sono tutte cose che deve fare paolo
			if (this.viewState.m == PageDetail.STATE_CREATE || this.viewState.m == PageDetail.STATE_UPDATE) {
				this.onFieldChangeValue(true);
			}
		}

	}




	setMandatoryAsteriskLabel(singleInput) {
		if (!singleInput.realMandatory) {
			return
		}
		let s = jQuery("label", singleInput.sinput).text();
		s += "*";
		jQuery("label", singleInput.sinput).text(s);

	}


	checkMandatory(singleInput) {
		// Controlla se è mandatory
		if (!singleInput.mandatory) {
			return true;
		}


		// è mandatory, controlla che sia valorizzato
		let input = this.getInput(singleInput);
		if (Array.isArray(input)) {
			// Nel caso di input nls controlla ogni campo (non dovrebbe mai accadere ma non si sa mai)
			for (let x = 0; x < input.length; x++) {
				let locale = input[x].data("fld-locale");
				for (let y = 0; y < this.data.row.Translations.length; y++) {
					if (this.data.row.Translations[y].Locale === locale) {
						let value = this.getInputValue(input[x], singleInput);
						if (!Pqp.isNullOrEmpty(value)) {
							return true;
						}
					}
				}
			}
			return false;
		} else {
			// Controlla il singolo
			let value = this.getInputValue(input, singleInput);
			if (Pqp.isNullOrEmpty(value)) {
				return false;
			}
		}
		return true;
	}

	checkEmail(singleInput) {
		let input = this.getInput(singleInput);
		let value = this.getInputValue(input, singleInput);
		let ret = {
			ok: true,
			message: "all okay" // 
		}

		if (!singleInput.realMandatory) {
			if (Pqp.isNullOrEmpty(value)) {
				return ret;
			}
		}

		if (!Pqp.validateEmail(value)) {
			ret = {
				ok: false,
				message: "the email format is incorrect" //
			}
		}
		return ret;

	}

	checkRegExpValidation(singleInput) {

		if (Pqp.isNullOrEmpty(singleInput.regexp)) {
			return
		}
		let ret = {
			ok: true,
			message: "all okay" // 
		}

		var re = new RegExp(singleInput.regexp);

		// è mandatory, controlla che sia valorizzato
		let input = this.getInput(singleInput);
		if (Array.isArray(input)) {
			// Nel caso di input nls controlla ogni campo (non dovrebbe mai accadere ma non si sa mai)
			for (let x = 0; x < input.length; x++) {
				let locale = input[x].data("fld-locale");
				for (let y = 0; y < this.data.row.Translations.length; y++) {
					if (this.data.row.Translations[y].Locale === locale) {
						let value = this.getInputValue(input[x], singleInput);
						if (!Pqp.isNullOrEmpty(value)) {
							if (!re.test(value)) {
								// Basta uno che non matchi che ritorna l'errore
								ret = {
									ok: false,
									message: "Validation error!"
								}
								return ret;
							}
						}
					}
				}
			}
			return ret;
		} else {
			// Controlla il singolo
			let value = this.getInputValue(input, singleInput);
			if (!Pqp.isNullOrEmpty(value)) {
				if (!re.test(value)) {
					ret = {
						ok: false,
						message: this.getRegexpMessage(singleInput)
					}
					return ret;
				}
			}
		}
		return ret;
	}
	getRegexpMessage(singleInput) {
		if (Pqp.isNullOrEmpty(singleInput.regexpmessage)) {
			return PageDetail.VALIDATION_ERROR_TEXT;
		}
		return singleInput.regexpmessage;
	}



	_setFormFields(bSetup, bSetSecurity, bSetValues) {
		// trova tutti i sets
		let sets = this.getInputSets();
		// Li analizza
		for (let x = 0; x < sets.length; x++) {
			if (sets[x].type === PageDetail.SET_SIMPLE) {
				/*if (x === 19) {
					debugger
				}*/
				this.initInputSetSimple(sets[x].iset, bSetup, bSetSecurity, bSetValues);
			}
			if (sets[x].type === PageDetail.SET_COMPLEX) {
				this.initInputSetComplex(sets[x], bSetup, bSetSecurity, bSetValues);
			}

		}
		return
	}

	initInputSetSimple(iset, bSetup, bSetSecurity, bSetValues) {
		// I set simple contengono solo un input
		let singleInput = this.getSingleInput(iset);
		this.initSingleInput(singleInput, bSetup, bSetSecurity, bSetValues);

	}

	// IMPORTANTE
	initSingleInput(singleInput, bSetup, bSetSecurity, bSetValues, bNoSetValueForced = false) {
		if (!singleInput.canView) {
			return
		}

		let input = this.getInput(singleInput)

		if (!input) {
			return
		}

		// Security e readonly
		if (bSetup || bSetSecurity) {
			let iset = singleInput.iset;
			if (singleInput.readonly) {
				this.setReadOnly(singleInput, true);
				// Rimuove l'evento di change
				this.removeChangeEvent(singleInput, input);
			} else {
				if (!Pqp.isNullOrEmpty(singleInput.dependency)) {
					// Se è una select ed è dipendente da un'altra controlla il numero di elementi
					let select = this.getInput(singleInput);
					// Se ce ne sono 0 o 1 (mandatory o no) allora disabilita la select
					let limit = 0;
					if (!singleInput.realMandatory) {
						limit = 1;
					}
					//debugger
					if (jQuery("option", select).length === limit) {
						this.setReadOnly(singleInput, true);
					} else {
						this.setReadOnly(singleInput, false);
					}
				} else {
					this.setReadOnly(singleInput, false);
				}
				// Abilita il save al primo change
				this.addChangeEvent(singleInput, input);
				// Aggiunge eventualmente il listener per nls-completion (non importa rimuoverlo)
				this.addCompletionChangeEvent(singleInput);


			}
		}

		// Eventuale * dove è mandatory
		if (bSetup) {
			this.setMandatoryAsteriskLabel(singleInput);
		}

		// Eventuale provider (inizializzato comunque solo in setup)
		//console.log(singleInput.name, bSetup)
		if (bSetup) {
			this.fillSelectFromProvider(singleInput);
			this.updateFillSetSelects(singleInput);
			this.initSelect2(singleInput);
			this.initShieldCommonComponents(singleInput);
		}

		// Eventuale switch nls
		if (bSetup) {
			this.initNlsSwitcher(singleInput);
		}

		// Eventuale info nsl
		if (bSetup) {
			this.initNlsInfo(singleInput);
		}

		// Eventuale upload
		if (bSetup) {
			this.initUpload(singleInput);
		}

		// Eventuale list
		if (bSetup) {
			this.initList(singleInput);
		}

		// Eventuale input numeric
		if (bSetup) {
			this.initFieldNumeric(singleInput);
		}
		// Eventuale input float
		if (bSetup) {
			this.initFieldFloat(singleInput);
		}

		if (bSetup) {
			this.initFieldInfo(singleInput);
		}


		// Valore
		if (bSetValues || bSetup) {
			if (!bNoSetValueForced) {
				this.setValueSingleInput(singleInput);
			}
		}

		if (this.viewState.m == PageDetail.STATE_CREATE) {
			// Mette il default
			this.setDefaultValue(singleInput);

		}


		this.updateAddListCaptionAndActions(singleInput); // solo list
		this.checkCompletion(singleInput); // solo nls


		// Controlla se togliere lo status approved dalla tendina 
		if (bSetSecurity) {
			// Sto pezzo profuma ma non saprei come farlo altrimenti 
			if (singleInput.provider === "_c_lookup_status") {
				// Se si sta creando il record o se si è già in update
				if (this.viewState.m === PageDetail.STATE_CREATE || this.viewState.m === PageDetail.STATE_UPDATE) {
					// Controlla l'acl
					if (!this.aclContext.HasGrantedAcl(new AuthCheckAcl(this.data.rowSUid, SecurityAcl.ACL_APPROVED))) {
						// In questo caso non ho i diritti di settare l'approved, lo rimuove dal provider
						let select = this.getInput(singleInput);
						let opts = jQuery("option", select);
						for (let x = 0; x < opts.length; x++) {
							let opt = jQuery(opts[x]);
							if (opt.val() === "9") { //Common.ACL_APPROVED)
								opt.remove();
							}
						}
					}
				}
			}
		}


		if (bSetup) {
			this.onFieldInited(singleInput)

		}



	}



	setDefaultValue(singleInput) {

		if (!singleInput.isnls) {
			// Campi semplici non in lingua
			let input = this.getInput(singleInput);
			//this.setInputValue(input, this.data.row[singleInput.name], singleInput)
			//debugger
			this.setDefaultInputValue(input, singleInput)
		} else {
			// Per ora non gestisce i default in lingua
			return
			/*
			// Campi semplici in lingua
			let inputs = this.getInput(singleInput);
			// Li valorizza in base alla lingua
			for (let x = 0; x < inputs.length; x++) {
				let locale = inputs[x].data("fld-locale");
				let value = this.findTranslationValue(singleInput, locale);
				//inputs[x].val(value);
				this.setInputValue(inputs[x], value, singleInput)
			}*/

		}

	}

	initFieldFloat(singleInput) {
		if (singleInput.type !== PageDetail.TYPE_INPUT_FLOAT) {
			return
		}
		let input = this.getInput(singleInput);

		input.on("propertychange input paste", this.textFloatChanged.bind(this, input, singleInput.name, singleInput.sset));
		input.on("focusin", this.gotFocus.bind(this, input, singleInput.name, singleInput.sset))
		input.on("focusout", this.lostFocus.bind(this, input, singleInput.name, singleInput.sset))

	}
	gotFocus(input, name, sset) {
		let singleInput = this.getSingleInputByName(name, sset);
		if (Array.isArray(singleInput)) {
			singleInput = singleInput[0];
		}
		let text = input.val();
		if (singleInput.decimalsSeparator === ",") {
			text = Pqp.safeReplace(text, ",", ".");
		}

		let vl = parseFloat(text);
		if (!isNaN(vl)) {
			if (singleInput.decimalsSeparator === ",") {
				vl = Pqp.safeReplace(text, ".", ",");
			}
			input.val(vl);
		}
	}
	initFieldInfo(singleInput) {
		const infoMessage = singleInput.sinput.data("fld-info");
		if (!infoMessage) {
			return;
		}

		const label = jQuery("label", singleInput.sinput);

		const infoIcon = jQuery(`
        <span class="info-icon tooltip" title="${infoMessage}">
            <i class="fa fa-info-circle" aria-hidden="true"></i>
        </span>`);

		label.append(infoIcon);
	}

	lostFocus(input, name, sset) {
		//debugger
		let singleInput = this.getSingleInputByName(name, sset);
		if (Array.isArray(singleInput)) {
			singleInput = singleInput[0];
		}

		/*let singleInput = this.getSingleInputByName(name);
		let input = this.getInput(singleInput);*/
		let text = input.val();
		if (singleInput.decimalsSeparator === ",") {
			text = Pqp.safeReplace(text, ",", ".");
		}

		let vl = parseFloat(text);
		//debugger
		if (!isNaN(vl)) {
			let p = "" + vl;
			if (p.indexOf(".") < 0) {
				p += ".";
			}
			let tmp = p.split(".");
			let dec = tmp[1];
			for (let x = dec.length; x < singleInput.decimals; x++) {
				dec += "0";
			}
			input.val(tmp[0] + singleInput.decimalsSeparator + dec);
		}


	}


	textFloatChanged(input, name, sset) {
		/*let singleInput = this.getSingleInputByName(name);
		let input = this.getInput(singleInput);*/

		let singleInput = this.getSingleInputByName(name, sset);
		if (Array.isArray(singleInput)) {
			singleInput = singleInput[0];
		}


		let text = input.val();
		let ok = "1234567890" + singleInput.decimalsSeparator
		if (singleInput.canBeNegative) {
			ok = "-" + ok
		}

		let tmp = ""
		for (let x = 0; x < text.length; x++) {
			let c = text.charAt(x);
			let lAdd = false
			if (ok.indexOf(c) >= 0) {
				lAdd = true;
			}
			if (c === singleInput.decimalsSeparator) {
				if (tmp.indexOf(c) >= 0) {
					lAdd = false;
				}
			}
			if ((c === "-") && (x > 0)) {
				lAdd = false;
			}

			if (tmp.indexOf(singleInput.decimalsSeparator) >= 0) {
				let cmp = tmp.split(singleInput.decimalsSeparator);
				if (cmp[1].length >= singleInput.decimals) {
					lAdd = false;
				}
			}


			if (lAdd) {
				tmp += c;
			}
		}

		// check su max e min
		if (singleInput.numericMin !== "dummy") {
			if (parseFloat(tmp) < singleInput.numericMin) {
				tmp = "" + singleInput.numericMin;
			}
		}

		if (singleInput.numericMax !== "dummy") {
			if (parseFloat(tmp) > singleInput.numericMax) {
				tmp = "" + singleInput.numericMax;
			}
		}



		input.val(tmp);

	}

	initFieldNumeric(singleInput) {
		if (singleInput.type !== PageDetail.TYPE_INPUT_NUMERIC) {
			return
		}
		let input = this.getInput(singleInput);

		input.on("propertychange input paste", this.textNumericChanged.bind(this, input, singleInput.name, singleInput.sset));
	}



	textNumericChanged(input, name, sset) {
		let singleInput = this.getSingleInputByName(name, sset);
		if (Array.isArray(singleInput)) {
			singleInput = singleInput[0];
		}
		/*let singleInput = this.getSingleInputByName(name);
		let input = this.getInput(singleInput);*/
		let text = input.val();
		let ok = "-1234567890"
		if (!singleInput.canBeNegative) {
			ok = "1234567890"
		}
		let tmp = ""

		for (let x = 0; x < text.length; x++) {
			let c = text.charAt(x);
			let lAdd = false
			if (ok.indexOf(c) >= 0) {
				lAdd = true;
			}
			if ((c === "-") && (x > 0)) {
				lAdd = false;
			}
			let lCheck = true;
			let len = parseInt(input.attr("maxlength"));
			if (isNaN(len)) {
				lCheck = false;
			}

			if (lCheck) {
				if (singleInput.canBeNegative) {
					if (tmp.charAt(0) !== "-") {
						if (tmp.length >= len - 1) {
							lAdd = false;
						}
					}

				} else {
					if (tmp.charAt(0) !== "-") {
						if (tmp.length >= len) {
							lAdd = false;
						}
					}

				}
			}

			if (lAdd) {
				tmp += c;
			}

		}

		// check su max e min
		if (singleInput.numericMin !== "dummy") {
			if (parseInt(tmp) < singleInput.numericMin) {
				tmp = "" + singleInput.numericMin;
			}
		}

		if (singleInput.numericMax !== "dummy") {
			if (parseInt(tmp) > singleInput.numericMax) {
				tmp = "" + singleInput.numericMax;
			}
		}

		input.val(tmp);
	}


	_getFormFields(row, bValidate) {
		let lSuccess = true;
		let message = "Operation completed successfully!";
		let ret;
		let ko = false;
		// trova tutti i sets
		let sets = this.getInputSets();
		// Li analizza
		for (let x = 0; x < sets.length; x++) {
			if (sets[x].type === PageDetail.SET_SIMPLE) {
				ret = this.getSimpleSetValues(row, bValidate, sets[x]);
				if (!ret) {
					ko = true;
				}
			}
			// Altri set to do
			if (sets[x].type === PageDetail.SET_COMPLEX) {
				ret = this.getComplexSetValues(row, bValidate, sets[x]);
				if (!ret) {
					ko = true;
				}
			}

		}

		if (ko) {
			message = "One or more value are incorrect, please check the form!";
			lSuccess = false;
		}

		return { Success: lSuccess, Message: message };
	}

	getSimpleSetValues(row, bValidate, sset) {

		//let singleInput = this.getSingleInput(sets[x].iset);
		let singleInput = this.getSingleInput(sset.iset);
		return this.getSingleInputValue(row, bValidate, singleInput)

	}

	getSingleInputValue(row, bValidate, singleInput) {
		let ret = true;

		// Resetta l'eventuale errore
		singleInput.sinput.removeClass("has-error");
		jQuery(".js-error-txt", singleInput.sinput).css("opacity", 0);
		if (singleInput.type === PageDetail.TYPE_LIST) {
			jQuery(".js-error-txt", singleInput.sinput).text(PageDetail.MANDATORY_TEXT_LIST);
		} else {
			jQuery(".js-error-txt", singleInput.sinput).text(PageDetail.MANDATORY_TEXT);
		}

		let source = row;
		if (singleInput.complex) {
			// Ricava il blocco
			let index = this.getBlockIndex(singleInput);
			//source = this.data.row[singleInput.sset.name][index];
			source = row[singleInput.sset.name][index];

		}

		// Legge i valori
		let input = this.getInput(singleInput);
		if (Array.isArray(input)) {
			// Nel caso di input nls (lingua multipla deve settare i valori dentro Translations )
			for (let x = 0; x < input.length; x++) {
				let locale = input[x].data("fld-locale");
				for (let y = 0; y < source.Translations.length; y++) {
					if (source.Translations[y].Locale === locale) {
						source.Translations[y][singleInput.name] = this.getInputValue(input[x], singleInput);
					}
				}
			}
		} else {
			// Setta il valore
			//debugger
			source[singleInput.name] = this.getInputValue(input, singleInput);
		}

		if (bValidate) {
			// effettua la validazione per il mandatory
			let ok = this.checkMandatory(singleInput);
			if (!ok) {
				ret = false;
				singleInput.sinput.addClass("has-error");
				jQuery(".js-error-txt", singleInput.sinput).css("opacity", 1);
			}
		}

		// Min Max
		if (bValidate) {
			//debugger
			if (singleInput.type === PageDetail.TYPE_LIST) {
				let n = source[singleInput.name];
				if (singleInput.listItemMin !== -1) {
					if (n.length < singleInput.listItemMin) {
						ret = false;
						singleInput.sinput.addClass("has-error");
						jQuery(".js-error-txt", singleInput.sinput).css("opacity", 1);
						let err = Pqp.safeReplace(PageDetail.MANDATORY_TEXT_LIST_MIN, "{{0}}", "" + singleInput.listItemMin);
						jQuery(".js-error-txt", singleInput.sinput).text(err);
					}
				}

			}
		}


		let feedback = null;

		if (bValidate) {
			// effettua eventualmente la validazione regExp
			if (singleInput.type === PageDetail.TYPE_INPUT_EMAIL) {
				feedback = this.checkEmail(singleInput);
			}
		}


		if (bValidate) {
			if (feedback) {
				if (feedback.ok) {
					// effettua eventualmente la validazione regExp
					feedback = this.checkRegExpValidation(singleInput);
				}
			} else {
				feedback = this.checkRegExpValidation(singleInput);
			}
		}

		if (feedback) {
			if (feedback.ok) {
				if (bValidate) {
					// effettua la validazione CUSTOM, eventualmente da overridare
					feedback = this.checkCustomValidation(singleInput);
				}
			}
		} else {
			if (bValidate) {
				// effettua la validazione CUSTOM, eventualmente da overridare
				feedback = this.checkCustomValidation(singleInput);
			}
		}

		if (feedback) {
			if (!feedback.ok) {
				jQuery(".js-error-txt", singleInput.sinput).text(feedback.message);
				singleInput.sinput.addClass("has-error");
				jQuery(".js-error-txt", singleInput.sinput).css("opacity", 1);
				ret = false;
			}
		}

		return ret;
	}

	removeListEntry(mc, name) {
		let singleInput = this.getSingleInputByName(name);
		mc.remove();
		this.updateAddListCaptionAndActions(singleInput);
		this.onFieldChangeValue(true);
		this.onFieldChanged(singleInput) 
	}

	entryValueToLabel(value, singleInput) {
		let provider = TheProviders[singleInput.provider];
		let result = provider.find(({ Value }) => Value === value);
		if (result.DisplayLabel) {
			return result.DisplayLabel;
		}
		return result.Label;
	}

	updateAddListCaptionAndActions(singleInput) {
		//debugger
		if (singleInput.type === PageDetail.TYPE_LIST) {
			//debugger
			let n = this.getInputValue(null, singleInput);
			if (n.length === 0) {
				jQuery(".js-no-entry", singleInput.sinput).show();
			} else {
				jQuery(".js-no-entry", singleInput.sinput).hide();
			}


			if (!Pqp.isNullOrEmpty(n[0])) {
				jQuery(".js-add-entry", singleInput.sinput).text("+ Add additional" + singleInput.listLabel);
			} else {
				jQuery(".js-add-entry", singleInput.sinput).text("+ Add" + singleInput.listLabel);
			}
			//debugger
			jQuery(".js-list-title", singleInput.iset).text(singleInput.listLabel)
			if (singleInput.readonly) {
				jQuery(".js-remove-entry", singleInput.sinput).hide();
				jQuery(".js-add-entry", singleInput.sinput).hide();

			} else {
				if ((this.viewState.m !== PageDetail.STATE_READ) && (this.aclContext.HasGrantedAcl(new AuthCheckAcl(this.data.rowSUid + singleInput.name, SecurityAcl.ACL_UPDATE)))) {
					jQuery(".js-remove-entry", singleInput.sinput).show();
					jQuery(".js-add-entry", singleInput.sinput).show();

					// Controlla un eventuale max entries
					if (singleInput.listItemMax !== -1) {
						if (n.length < singleInput.listItemMax) {
							jQuery(".js-add-entry", singleInput.sinput).show();
						} else {
							jQuery(".js-add-entry", singleInput.sinput).hide();
						}
					}
					//debugger
					if ((singleInput.listItemMin !== -1) && (singleInput.listItemMax !== -1)) {
						jQuery(".js-list-title", singleInput.iset).text(singleInput.listLabel + " (min. " + singleInput.listItemMin + ", max. " + singleInput.listItemMax + ")");
					} else {
						if (singleInput.listItemMin !== -1) {
							jQuery(".js-list-title", singleInput.iset).text(singleInput.listLabel + " (min. " + singleInput.listItemMin + ")");
						} else if (singleInput.listItemMax !== -1) {
							jQuery(".js-list-title", singleInput.iset).text(singleInput.listLabel + " (max. " + singleInput.listItemMax + ")");
						}

					}

				} else {
					// Nasconde tutto
					jQuery(".js-remove-entry", singleInput.sinput).hide();
					jQuery(".js-add-entry", singleInput.sinput).hide();
				}
			}
		}

	}


	/*
	__          _______            _____  _____  ______ _____
	\ \        / /  __ \     /\   |  __ \|  __ \|  ____|  __ \
	 \ \  /\  / /| |__) |   /  \  | |__) | |__) | |__  | |__) |
		\ \/  \/ / |  _  /   / /\ \ |  ___/|  ___/|  __| |  _  /
		 \  /\  /  | | \ \  / ____ \| |    | |    | |____| | \ \
			\/  \/   |_|  \_\/_/    \_\_|    |_|    |______|_|  \_\
		
		*/


	initShieldCommonComponents(singleInput) {
		// Text area shieldui
		if (singleInput.shielduiEditor) {
			let input = this.getInput(singleInput);
			input.shieldEditor({
				height: 'auto',
				commands: [
					"formatBlock", "removeFormat",
					"bold", "italic", "underline",
					"insertUnorderedList", "insertOrderedList",
					"justifyLeft", "justifyCenter", "justifyRight", "justifyFull",
					"createLink", "unlink",
					"indent", "outdent"
				],
				events: {
					keydown: this.onFieldChangeValue.bind(this, true)
				}
			});
		}
	}


	getInputValue(input, singleInput) {
		// Per ora ritorna il val, in futuro in base al tipo di input bisognerà magari cambiare qualcosa
		// List
		if (singleInput.type === PageDetail.TYPE_LIST) {
			let ret = [];
			let entries = jQuery(".js-single-entry", singleInput.sinput);
			for (let x = 0; x < entries.length; x++) {
				if (!jQuery(entries[x]).hasClass("list-template")) {
					ret.push(jQuery(entries[x]).data("fld-uid"));
				}
			}
			return ret;
		}
		// Upload
		if (singleInput.type === PageDetail.TYPE_UPLOAD) {
			let hidden = jQuery(".js-upload-value", jQuery(input.get(0)).parent());
			return hidden.val();
		}

		// Checkbox
		if (singleInput.type === PageDetail.TYPE_CHECKBOX) {
			if (input.is(":checked")) {
				return true;
			}
			return false;
		}

		let value = input.val();
		if (Pqp.isNullOrEmpty(value)) {
			return null
		}

		return value;
	}

	clickedListEntry(id, singleInput) {
		if (singleInput.listhrefBlank) {
			window.open(singleInput.listhref + id, "_blank");
		} else {
			document.location.href = singleInput.listhref + id;
		}
	}

	setDefaultInputValue(input, singleInput) {
		// Aggiungerne altri
		this.setInputValue(input, singleInput.default, singleInput)

	}
	setInputValue(input, value, singleInput, lIgnoreEmpty) {
		// ListSelect
		if (singleInput.type === PageDetail.TYPE_LIST) {
			let template = jQuery(".list-template", singleInput.sinput);
			jQuery(".js-single-entry", singleInput.sinput).remove();
			let n = 0;
			if (Pqp.isNullOrEmpty(value)) {
				value = [];
			}


			for (let x = 0; x < value.length; x++) {
				let provider = TheProviders[singleInput.provider];
				let exists = provider.find(({ Value }) => Value === value[x]);
				if (!Pqp.isNullOrEmpty(exists)) {
					n++;
					let mc = template.clone();
					mc.removeClass("list-template");
					mc.attr("data-fld-uid", value[x]);
					jQuery(".js-value", mc).text(this.entryValueToLabel(value[x], singleInput))
					if (!Pqp.isNullOrEmpty(singleInput.listhref)) {
						jQuery(".js-value", mc).on("click", this.clickedListEntry.bind(this, value[x], singleInput));
						jQuery(".js-value", mc).css("cursor", "pointer");
					}
					jQuery(".js-remove-entry", mc).on("click", this.removeListEntry.bind(this, mc, singleInput.name));
					jQuery(".js-entries", singleInput.sinput).append(mc);
					mc.show();
				} else {
					console.log("Attenzione! Non ho trovato un riferimento a " + value[x] + " nel provider " + singleInput.provider);
				}
			}
			jQuery(".js-entries", singleInput.sinput).prepend(template);
			this.updateAddListCaptionAndActions(singleInput);
			return
		}

		// Upload
		if (singleInput.type === PageDetail.TYPE_UPLOAD) {
			if (Pqp.isNullOrEmpty(value)) {
				let parent = jQuery(input.get(0)).parent();
				$(".js-upload-clear", parent).hide();
			} else {
				// Upload
				let parent = jQuery(input.get(0)).parent();
				let hidden = jQuery(".js-upload-value", parent);
				hidden.val(value);
				let file = value.split("/")
				file = file[file.length - 1];
				let name = file;
				try {
					name = Base64.decode((value.split("_")[1]).split(".")[0]);
				} catch (e) {
				}
				$(".js-upload-link", parent).text(name);
				$(".js-upload-link", parent).attr("href", value);
				$(".js-upload-clear", parent).show();
				let thumb = value + ".thumb.jpg";
				$(".js-upload-image", parent).css("background-image", "url(" + thumb + ")");


				//js-upload-image
			}
			return
		}

		// Checkbox
		if (singleInput.type === PageDetail.TYPE_CHECKBOX) {
			jQuery(input.get(0)).prop("checked", false);
			if (("" + value).toLowerCase() === "on") {
				jQuery(input.get(0)).prop("checked", true);
			}
			if (("" + value).toLowerCase() === "true") {
				jQuery(input.get(0)).prop("checked", true);
			}
			return
		}


		if (!lIgnoreEmpty) {
			if (Pqp.isNullOrEmpty(value) && (value !== 0)) {
				return
			}
		}

		// Per ora setta il val, in futuro in base al tipo di input bisognerà magari cambiare qualcosa (in realtà abbiamo già aggiunto roba custom)
		if (!Pqp.isNullOrEmpty(singleInput.provider)) {
			let select = this.getInput(singleInput);
			let select2// = select.select2();
			if (Pqp.isNullOrEmpty(singleInput.selectTemplate)) {
				select2 = select.select2();
			} else {
				select2 = select.select2({
					templateSelection: this[singleInput.selectTemplate].bind(this, singleInput),
					templateResult: this[singleInput.selectTemplate].bind(this, singleInput)
				});
			}

			select2.val(value);
			select2.trigger('change');
			return
		}

		if (singleInput.shielduiEditor) {
			input.swidget().value(value);
			return
		}


		input.val(value);

		if (singleInput.type === PageDetail.TYPE_INPUT_FLOAT) {
			this.lostFocus(input, singleInput.name, singleInput.sset)
		}


	}

	removeChangeEvent(singleInput, input) {
		// Rimuove l'evento di change
		// Eventualmente da gestire per altri elementi in cui il change non fa nulla
		if (Array.isArray(input)) {
			for (let x = 0; x < input.length; x++) {
				input[x].off("change")
				if ((singleInput.type === PageDetail.TYPE_INPUT) || (singleInput.type === PageDetail.TYPE_INPUT_EMAIL) || (singleInput.type === PageDetail.TYPE_INPUT_FLOAT) || (singleInput.type === PageDetail.TYPE_INPUT_NUMERIC) || (singleInput.type === PageDetail.TYPE_TEXTAREA) || (singleInput.type === PageDetail.TYPE_NLSINPUT) || (singleInput.type === PageDetail.TYPE_NLSTEXTAREA)) {
					input[x].off("keydown");
				}
			}
		} else {
			input.off("change")
			if ((singleInput.type === PageDetail.TYPE_INPUT) || (singleInput.type === PageDetail.TYPE_INPUT_EMAIL) || (singleInput.type === PageDetail.TYPE_INPUT_FLOAT) || (singleInput.type === PageDetail.TYPE_INPUT_NUMERIC) || (singleInput.type === PageDetail.TYPE_TEXTAREA) || (singleInput.type === PageDetail.TYPE_NLSINPUT) || (singleInput.type === PageDetail.TYPE_NLSTEXTAREA)) {
				input.off("keydown");
			}
		}
	}

	addChangeEvent(singleInput, input) {

		// Abilita il save al primo change
		// Eventualmente da gestire per altri elementi in cui il change non fa nulla
		if (Array.isArray(input)) {
			for (let x = 0; x < input.length; x++) {
				input[x].on("change", this.onFieldChangeValue.bind(this, true));
				input[x].on("change", this.onFieldChanged.bind(this, singleInput, input));
				if ((singleInput.type === PageDetail.TYPE_INPUT) || (singleInput.type === PageDetail.TYPE_INPUT_EMAIL) || (singleInput.type === PageDetail.TYPE_INPUT_FLOAT) || (singleInput.type === PageDetail.TYPE_INPUT_NUMERIC) || (singleInput.type === PageDetail.TYPE_TEXTAREA) || (singleInput.type === PageDetail.TYPE_NLSINPUT) || (singleInput.type === PageDetail.TYPE_NLSTEXTAREA)) {
					input[x].on("keydown", this.onFieldChangeValue.bind(this, true));
					input[x].on("keydown", this.onFieldChanged.bind(this, singleInput, input));
				}
			}
		} else {
			input.on("change", this.onFieldChangeValue.bind(this, true));
			input.on("change", this.onFieldChanged.bind(this, singleInput, input));
			if ((singleInput.type === PageDetail.TYPE_INPUT) || (singleInput.type === PageDetail.TYPE_INPUT_EMAIL) || (singleInput.type === PageDetail.TYPE_INPUT_FLOAT) || (singleInput.type === PageDetail.TYPE_INPUT_NUMERIC) || (singleInput.type === PageDetail.TYPE_TEXTAREA) || (singleInput.type === PageDetail.TYPE_NLSINPUT) || (singleInput.type === PageDetail.TYPE_NLSTEXTAREA)) {
				input.on("keydown", this.onFieldChangeValue.bind(this, true));
				input.on("keydown", this.onFieldChanged.bind(this, singleInput, input));
			}
		}
	}


	addCompletionChangeEvent(singleInput) {
		// Change event per il completion
		if (!singleInput.isnls) {
			return;
		}
		let inputs = this.getInput(singleInput);
		// Eventualmente da gestire per altri elementi in cui il change non fa nulla
		for (let x = 0; x < inputs.length; x++) {
			inputs[x].on("change", this.checkCompletion.bind(this, singleInput));
		}

	}

	checkCompletion(singleInput) {
		if (!singleInput.isnls) {
			return;
		}
		let inputs = this.getInput(singleInput);
		let nOk = 0;
		for (let x = 0; x < inputs.length; x++) {
			let locale = inputs[x].data("fld-locale");
			let value = this.getInputValue(inputs[x], singleInput);
			let lng = jQuery(".nls-completion-item-" + locale, singleInput.sinput);
			lng.removeClass("nls-completion-item-incomplete");
			if (Pqp.isNullOrEmpty(value)) {
				lng.addClass("nls-completion-item-incomplete");
			} else {
				nOk++;
			}
		}
		if (nOk === inputs.length) {
			jQuery(".js-nls-completion", singleInput.sinput).hide();
		} else {
			jQuery(".js-nls-completion", singleInput.sinput).show();
		}
	}


	setReadOnly(singleInput, lFlag) {
		let iset = singleInput.sinput;
		if (lFlag) {
			iset.addClass("read-only");
			$("input", $(iset)).attr("disabled", true);
			$("textarea", $(iset)).attr("disabled", true);
			$('input[type="button"]').addClass("disabled");
			// Select2
			if (!Pqp.isNullOrEmpty(singleInput.provider)) {
				let select = this.getInput(singleInput);
				select.prop("disabled", true);
			}
		} else {
			iset.removeClass("read-only");
			$("input", $(iset)).attr("disabled", false);
			$("textarea", $(iset)).attr("disabled", false);
			$('input[type="button"]').removeClass("disabled");
			// Select2
			if (!Pqp.isNullOrEmpty(singleInput.provider)) {
				let select = this.getInput(singleInput);
				select.prop("disabled", false);
			}
		}
	}


	/*
	 _______ ____    ______      ________ _____  _____  _____ _____  ______
	|__   __/ __ \  / __ \ \    / /  ____|  __ \|  __ \|_   _|  __ \|  ____|
		| | | |  | | | |  | \ \  / /| |__  | |__) | |__) | | | | |  | | |__
		| | | |  | | | |  | |\ \/ / |  __| |  _  /|  _  /  | | | |  | |  __|
		| | | |__| | | |__| | \  /  | |____| | \ \| | \ \ _| |_| |__| | |____
		|_|  \____/   \____/   \/   |______|_|  \_\_|  \_\_____|_____/|______|
	*/

	checkCustomValidation(singleInput) {
		// To override, deve restituire però questa struttura
		let ret = {
			ok: true,
			message: "all okay" // 
		}
		return ret;
	}

	filterOption(singleInput, data, valueToInsert) {
		// to override
		return true;
	}

	handleErrors(rs) {
		// to override (in base allo StatusCode magari cambia ll messaggio )
		return PageDetail.GENERIC_SAVE_ERROR;
	}
	getFieldErrorReturnedByServer(rs, code) {
		// to override (in base al code deve restituire il messaggio appropriato per il campo)
		return code;
	}

	onFieldChanged(singleInput) {
		// To override chiamata ad ogni cambiamento di valore
		//console.log("CHANGED")
	}

	onFieldInited(singleInput) {
		// To override chaimata quando il cmapo è stato inizializzato
		//console.log("INITED")
	}

	onBlockDeleted(sset) {
		// To override chimata quando si cancella un blocco di complex set

	}



	/*
		_____ ____  __  __ _____  _      ________   __
	 / ____/ __ \|  \/  |  __ \| |    |  ____\ \ / /
	| |   | |  | | \  / | |__) | |    | |__   \ V /
	| |   | |  | | |\/| |  ___/| |    |  __|   > <
	| |___| |__| | |  | | |    | |____| |____ / . \
	 \_____\____/|_|  |_|_|    |______|______/_/ \_\
	*/

	initInputSetComplex(sset, bSetup, bSetSecurity, bSetValues) {
		// I set complex contengono più campi in più blocchi
		//let singleInput = this.getSingleInput(iset);
		//this.initSingleInput(singleInput, bSetup, bSetSecurity, bSetValues);
		if (bSetup) {
			// In fase di setup ottiene il template 
			let template = jQuery(".block-template", sset.iset);
			template.remove();
			this.templates[sset.name] = template;
			// Controlla quindi se creare i blocchi se si è in modifica o un blocco se si è in inserimento
			if (this.viewState.m === PageDetail.STATE_CREATE) {
				// Create
				//if (sset.atLeastOne) {
				for (let x = 0; x < sset.blocksMin; x++) {
					// Almeno uno 
					this.createBlock(sset);
					//}
				}



			} else {
				// Eventuali entries
				let entries = this.data.row[sset.name];
				if (entries) {
					for (let x = 0; x < entries.length; x++) {
						// this.createBlock(sset, entries[x].UidRow);
						this.createBlock(sset, entries[x].Uid);
					}
				}
				if ((!entries) || (entries.length === 0)) {
					//if (sset.atLeastOne) {
					// Almeno uno comunque (se non ci sono entries)
					for (let x = 0; x < sset.blocksMin; x++) {
						this.createBlock(sset);
					}
					//}
				} else {
					for (let x = 0; x < sset.blocksMin - entries.length; x++) {
						this.createBlock(sset);
					}
				}
			}
		}

		let entries = jQuery(".js-single-block", sset.iset);
		for (let x = 0; x < entries.length; x++) {
			let block = jQuery(entries[x])
			this.initSingleInputOfABlock(sset, block, bSetup, bSetSecurity, bSetValues);
		}


		if (bSetSecurity) {
			this.updateBlockActions(sset);
		}
	}


	createBlock(sset, UidRow = "dummy") {
		// Aggiunge un blocco e lo inizializza
		let template = this.templates[sset.name];
		let block = template.clone();
		block.removeClass("block-template");
		if (UidRow === "dummy") {
			block.attr("id", Pqp.newGuid());
			block.attr("data-fld-new", "true");
		} else {
			block.attr("id", UidRow);
		}

		jQuery(".js-blocks", sset.iset).append(block);

		// Crea al volo anche gli eventuali input nls 
		let aree = jQuery(".js-input-area-nls", block);
		for (let x = 0; x < aree.length; x++) {
			let area = jQuery(aree[x]);
			this.createNlsInputs(area);

			/*let input = area.children().first();
			input.remove();
			for (let y = 0; y < this.data.locales.length; y++) {
				let inputnls = input.clone();
				area.append(inputnls);
				inputnls.attr("data-fld-locale", this.data.locales[y].Uid);
				if (y > 0) {
					inputnls.hide();
				}
			}*/
		}

		this.updateBlockActions(sset);
		return block;
	}

	updateBlockActions(sset) {
		// Se sono in modifica o in create allora visualizza i vari delete e valorizza il pulsante per aggiungere, altrimenti nasconde tutto (anche il pulsante aggiungi)

		// Conta le entries
		let entries = jQuery(".js-single-block", sset.iset);
		// Le rinumera
		if (entries.length === 1) {
			// Label semplice senza conto
			jQuery(".js-block-name", jQuery(entries[0])).text(sset.label);
		} else {
			for (let x = 0; x < entries.length; x++) {
				jQuery(".js-block-name", jQuery(entries[x])).text(sset.label + " " + (x + 1));
			}
		}


		if ((this.viewState.m !== PageDetail.STATE_READ) && (this.aclContext.HasGrantedAcl(new AuthCheckAcl(this.data.rowSUid + sset.name, SecurityAcl.ACL_UPDATE)))) {
			// Caption e click di add
			//debugger
			jQuery(".js-add-block", sset.iset).show();
			jQuery(".js-add-block", sset.iset).off("click"); // Per evitare gli eventi multipli che si genererebbero
			jQuery(".js-add-block", sset.iset).on("click", this.onAddNewBlock.bind(this, sset));
			if (entries.length === 0) {
				jQuery(".js-add-block", sset.iset).text("+ Add a " + sset.label.toLowerCase());
			} else {
				jQuery(".js-add-block", sset.iset).text("+ Add additional " + sset.label.toLowerCase());
			}
			// Delete entry
			for (let x = 0; x < entries.length; x++) {
				let entry = jQuery(entries[x]);
				jQuery(".js-remove-block", entry).off("click");
				jQuery(".js-remove-block", entry).on("click", this.onRemoveBlock.bind(this, sset, entry));
				jQuery(".js-remove-block", entry).show();
			}
			/*if (entries.length === 1) {
				if (sset.atLeastOne) {
					// Almeno una ci deve essere 
					jQuery(".js-remove-block", jQuery(entries[0])).hide();
				}
			}*/
			if (entries.length <= sset.blocksMin) {
				//if (sset.atLeastOne) {
				// Almeno una ci deve essere 
				//jQuery(".js-remove-block", jQuery(entries[0])).hide();
				jQuery(".js-remove-block", sset.iset).hide();
				//}
			}
			if (sset.blocksMax !== -1) {
				if (entries.length < sset.blocksMax) {
					jQuery(".js-add-block", sset.iset).show();
				} else {
					jQuery(".js-add-block", sset.iset).hide();
				}
			}

		} else {
			// Nasconde tutto
			jQuery(".js-remove-block", sset.iset).hide();
			jQuery(".js-add-block", sset.iset).hide();
		}


	}

	onAddNewBlock(sset) {
		let block = this.createBlock(sset);
		//debugger
		this.initSingleInputOfABlock(sset, block, true, true, true, true);

		// Scrolla al blocco
		let h = block.outerHeight();
		var body = $("html, body");
		let scroll = body.scrollTop();
		body.stop().animate({ scrollTop: scroll + h }, 500, 'swing');
		// Form toccata
		this.onFieldChangeValue(true);
		if (this.demo) {
			setTimeout(this.initClickHelp.bind(this), 500)
		}
	}

	onRemoveBlock(sset, entry) {
		// Sparisce in modo animato
		jQuery(".js-remove-block", entry).off("click");
		entry.slideUp(500, this.onSlidedUp.bind(this, entry, sset));

		// Form toccata
		this.onFieldChangeValue(true);


	}




	onSlidedUp(entry, sset) {
		// Viene rimosso effettivamente e aggiornata numerazione etc etc
		entry.remove();

		let entries = jQuery(".js-single-block", sset.iset);
		let singleInput = this.getSingleInputOfABlock(jQuery(".single-input", jQuery(entries.get(0))), sset, jQuery(entries.get(0)))
		this.updateFillSetSelects(singleInput);

		this.updateBlockActions(sset);
		// Evento da overridare
		this.onBlockDeleted(sset);


	}

	initSingleInputOfABlock(sset, block, bSetup, bSetSecurity, bSetValues, bNoSetValueForced) {
		// Prende tutti i single input di un blocco
		let clips = jQuery(".single-input", block);
		for (let x = 0; x < clips.length; x++) {
			let singleInput = this.getSingleInputOfABlock(jQuery(clips[x]), sset, block);
			this.initSingleInput(singleInput, bSetup, bSetSecurity, bSetValues, bNoSetValueForced);
		}

	}

	getInputSets() {
		let a = jQuery(".input-set");
		let ret = new Array();
		for (let x = 0; x < a.length; x++) {
			let iset = jQuery(a[x]);
			let o = new Object();
			o.type = iset.data("set-type");
			o.name = this.toS(iset.data("set-name"));
			o.atLeastOne = this.toB(iset.data("set-at-least-one"));
			o.label = this.toS(iset.data("set-label"));

			o.blocksMin = this.toN(iset.data("set-min-blocks"));
			o.blocksMax = this.toN(iset.data("set-max-blocks"));
			o.blocksMaxFromProvider = this.toS(iset.data("set-max-from-provider"));
			if (o.blocksMaxFromProvider !== null) {
				//debugger
				let count = this.fillSelectFromProvider({ type: PageDetail.TYPE_SELECT, provider: o.blocksMaxFromProvider, justCount: true })
				o.blocksMax = count.length;
			}


			if (o.atLeastOne) {
				if (o.blocksMin === -1) {
					o.blocksMin = 1;
				}
			}
			if (o.blocksMin === -1) {
				o.blocksMin = 0;
			}
			if (o.blocksMax > -1) {
				// Lamerata?
				if (o.blocksMax < o.blocksMin) {
					console.log("Attenzione, set-max-blocks minore di set-min-blocks!")
					o.blocksMax = o.blocksMin;
				}
			}


			o.iset = iset;
			ret.push(o);
		}
		return ret;
	}

	getSingleInputOfABlock(input, sset, block) {
		//console.log(sset);
		let o = this.getSingleInput(sset.iset, input); // lo tratta come un single input normale ma poi ricontrolla la security etc etc
		/*if (o.name === "FromYear") {
			debugger
		}*/
		o.readonly = this.toB(input.data("fld-readonly")) || this.viewState.m === PageDetail.STATE_READ || !this.aclContext.HasGrantedAcl(new AuthCheckAcl(this.data.rowSUid + sset.name + "|" + o.name, SecurityAcl.ACL_UPDATE));
		// Se per caso il blocco è nuovo, non si considera il readonlyEdit, altrimenti sì
		//debugger
		let value = block.attr("data-fld-new");
		let justAdded = this.toB(value);
		if (!justAdded) {
			if (this.viewState.m === PageDetail.STATE_UPDATE) {
				if (o.readonlyEdit) {
					o.readonly = true;
				}
			}
		}


		o.mandatory = o.readonly ? false : this.toB(input.data("fld-mandatory"));
		o.canView = this.aclContext.HasGrantedAcl(new AuthCheckAcl(this.data.rowSUid + sset.name + "|" + o.name, SecurityAcl.ACL_READ));
		o.block = block;
		o.complex = true;
		o.shielduiEditor = this.toB(input.data("fld-shieldui-editor"));
		o.sset = sset;


		if (!o.canView) {
			// Non può vederlo, lo ranza
			input.remove();
			o.readonly = true;
			o.mandatory = false;
		}
		return o;
	}


	getSingleInput(iset, clip = null) {
		let input = jQuery(".single-input", iset);
		if (clip) {
			input = clip;
		}

		let o = new Object();
		o.name = this.toS(input.data("fld-name"));
		o.type = this.toS(input.data("fld-type"));
		o.isnls = this.toB(input.data("fld-isnls"));
		//console.log(input.data("fld-default"));
		o.default = this.toS(input.data("fld-default"));
		if (!o.default) {
			// Controlla se sono stati passati dei valori (come se fosse una valorizzazione in modifica)
			if (this.viewState.m === PageDetail.STATE_CREATE) {
				if (!o.isnls) {
					o.default = this.data.row[o.name];
				}
			}
		}


		o.readonly = this.toB(input.data("fld-readonly")) || this.viewState.m === PageDetail.STATE_READ || !this.aclContext.HasGrantedAcl(new AuthCheckAcl(this.data.rowSUid + o.name, SecurityAcl.ACL_UPDATE));
		o.realMandatory = this.toB(input.data("fld-mandatory"));
		o.mandatory = o.readonly ? false : this.toB(input.data("fld-mandatory"));
		o.provider = this.toS(input.data("fld-provider"));

		o.readonlyEdit = this.toB(input.data("fld-readonly-edit"));
		if (this.viewState.m === PageDetail.STATE_UPDATE) {
			if (o.readonlyEdit) {
				o.readonly = true;
			}
		}
		o.fillsSelect = this.toS(input.data("fld-fills-select")); // Solo per le select (va a fillare che select)
		o.dependency = this.toS(input.data("fld-dependency")); // Solo per le select (il fill dipende da qualche select)
		o.iset = iset;	// il set
		o.sinput = input;	// il single input
		o.block = iset; // coincide con l'iset quello non dentro ad un block
		o.complex = false;
		o.shielduiEditor = this.toB(input.data("fld-shieldui-editor"));
		//this.initSelect2(o); // Se è una select 2 la inizializza e si prende il riferimento
		o.uploadRules = this.toS(input.data("fld-upload-rules")); // Solo per gli upload
		o.uploadCaption = this.toS(input.data("fld-upload-caption")); // Solo per gli upload

		if (!o.uploadCaption) {
			o.uploadCaption = "Browse"
		}
		o.resetCaption = this.toS(input.data("fld-reset-caption")); // Solo per gli upload
		if (!o.resetCaption) {
			o.resetCaption = "Reset"
		}
		o.thumbw = parseInt(this.toS(input.data("fld-thumb-w"))); // Solo per gli upload
		o.thumbh = parseInt(this.toS(input.data("fld-thumb-h"))); // Solo per gli upload
		if (isNaN(o.thumbw)) {
			o.thumbw = 128;
		}
		if (isNaN(o.thumbh)) {
			o.thumbh = 128;
		}

		o.thumbCaption = this.toS(input.data("fld-thumb-caption")); // Solo per gli upload

		o.listLabel = this.toS(input.data("fld-label")) // Solo per le list
		//console.log(o.listLabel)
		if (Pqp.isNullOrEmpty(o.listLabel)) {
			o.listLabel = "...";
		} else {
			o.listLabel = " " + o.listLabel;
		}

		o.canBeNegative = this.toB(input.data("fld-negative"));// Solo i numeric
		if (o.type === PageDetail.TYPE_INPUT_NUMERIC) {
			o.numericMin = this.toNumeric(input.data("fld-min")); // Solo i numeric 
			o.numericMax = this.toNumeric(input.data("fld-max")); // Solo i numeric 
		}
		if (o.type === PageDetail.TYPE_INPUT_FLOAT) {
			o.numericMin = this.toFloat(input.data("fld-min")); // Solo i numeric 
			o.numericMax = this.toFloat(input.data("fld-max")); // Solo i numeric 
		}

		o.decimals = this.toN(input.data("fld-decimals")); // Solo i decimals
		if (o.decimals === -1) {
			o.decimals = 2;
		}
		o.commaSeparator = this.toB(input.data("fld-comma-separator")); // Solo i decimals
		if (o.commaSeparator) {
			o.decimalsSeparator = ","
		} else {
			o.decimalsSeparator = "."
		}


		o.listItemMin = this.toN(input.data("fld-min-entries")); // Solo per le list
		o.listItemMax = this.toN(input.data("fld-max-entries")); // Solo per le list
		o.removeDiacritics = this.toB(input.data("fld-diacritics"));// Solo per le list
		o.listhref = this.toS(input.data("fld-list-href"));// Solo per le list
		o.listhrefBlank = this.toB(input.data("fld-list-href-target-blank"));// Solo per le list
		o.listMultiple = this.toB(input.data("fld-list-multiple"));// Solo per le list

		o.selectTemplate = this.toS(input.data("fld-select-template"));

		o.canView = this.aclContext.HasGrantedAcl(new AuthCheckAcl(this.data.rowSUid + o.name, SecurityAcl.ACL_READ));
		o.regexp = this.toS(input.data("fld-regexp"));
		o.regexpmessage = this.toS(input.data("fld-regexp-message"));
		if (!clip) {
			if (!o.canView) {
				// Non può vederlo, lo ranza
				iset.parent().remove();
				iset.remove();
				o.readonly = true;
				o.mandatory = false;
			}
		}

		if (input.length !== 0) {
			// Controlli aggiuntivi per segnalare qualche dimenticanza
			if (Pqp.isNullOrEmpty(o.name)) {
				alert("Attenzione! Ho trovato un single input senza 'fld-name', controllare (su console il riferimento al nodo) ")
				console.log(iset)
			}
			if (Pqp.isNullOrEmpty(o.type)) {
				alert("Attenzione! Ho trovato un single input senza 'fld-type', controllare (su console il riferimento al nodo) ")
				console.log(iset)
			}
		}

		return o;
	}

	setValueSingleInput(singleInput) {
		if (this.viewState.m === PageDetail.STATE_CREATE) {
			return;
		}
		let source = this.data.row;

		if (singleInput.complex) {
			// Ricava il blocco
			let index = this.getBlockIndex(singleInput);
			if (this.data.row[singleInput.sset.name]) {
				source = this.data.row[singleInput.sset.name][index];
			} else {
				source = null;
			}
		}
		if (!source) {
			return
		}


		if (!singleInput.isnls) {
			// Campi semplici non in lingua
			let input = this.getInput(singleInput);
			//this.setInputValue(input, this.data.row[singleInput.name], singleInput)
			this.setInputValue(input, source[singleInput.name], singleInput)
		} else {
			// Campi semplici in lingua
			let inputs = this.getInput(singleInput);
			// Li valorizza in base alla lingua
			for (let x = 0; x < inputs.length; x++) {
				let locale = inputs[x].data("fld-locale");
				let value = this.findTranslationValue(singleInput, locale);
				//inputs[x].val(value);
				this.setInputValue(inputs[x], value, singleInput)
			}

		}

	}

	getBlockIndex(singleInput) {
		let entries = jQuery(".js-single-block", singleInput.sset.iset);
		let index = -1;
		for (let x = 0; x < entries.length; x++) {
			if (jQuery(entries[x]).attr("id") === singleInput.block.attr("id")) {
				index = x;
				break;
			}
		}
		return index;
	}

	findTranslationValue(singleInput, locale) {
		let name = singleInput.name;
		let source = this.data.row;
		if (singleInput.complex) {
			// Ricava il blocco
			let index = this.getBlockIndex(singleInput);
			source = this.data.row[singleInput.sset.name][index];
		}
		let a = source.Translations;
		for (let x = 0; x < a.length; x++) {
			if (a[x].Locale === locale) {
				return a[x][name];
			}
		}
		alert("Critical! Non ho trovato la traduzione di " + name + " in " + locale);
		return null;
	}

	getComplexSetValues(row, bValidate, sset) {
		let ret = true;
		let entries = jQuery(".js-single-block", sset.iset);

		// Mette a posto la struttura dei dati in memoria per i blocchi
		this.checkDataStruct(row, sset);

		for (let x = 0; x < entries.length; x++) {
			let block = jQuery(entries[x])
			let ok = this.getValueOfSingleInputOfABlock(row, bValidate, sset, block);
			if (!ok) {
				ret = false;
			}
		}
		return ret;
	}

	checkDataStruct(row, sset) {
		// Controlla se esiste l'entry di ogni block nela struttura, altrimenti ne crea una vuota con il nuovo id assegnato al blocco in creazione
		if (!row[sset.name]) {
			row[sset.name] = new Array();
		}
		let a = row[sset.name];
		let tmp = new Array();
		let entries = jQuery(".js-single-block", sset.iset);
		for (let x = 0; x < entries.length; x++) {
			let block = jQuery(entries[x]);
			let UidRow = block.attr("id");
			let lFound = false;
			for (let y = 0; y < a.length; y++) {
				// if (a[y].UidRow === UidRow) {
				if (a[y].Uid === UidRow) {
					tmp.push(a[y]);
					lFound = true;
					break;
				}
			}
			if (!lFound) {
				// Pusha un'entry vuota
				let o = new Object();
				// o.UidRow = UidRow;
				o.Uid = UidRow;
				o.Translations = new Array();
				for (let z = 0; z < this.data.locales.length; z++) {
					o.Translations.push(this.getSingleTranslationDefault(this.data.locales[z]));
				}
				tmp.push(o);
			}
		}
		row[sset.name] = tmp;
	}

	getValueOfSingleInputOfABlock(row, bValidate, sset, block) {
		// Prende tutti i single input di un blocco
		let ret = true;
		let clips = jQuery(".single-input", block);
		for (let x = 0; x < clips.length; x++) {
			let singleInput = this.getSingleInputOfABlock(jQuery(clips[x]), sset, block);
			let ok = this.getSingleInputValue(row, bValidate, singleInput)
			if (!ok) {
				ret = false;
			}
		}
		return ret;

	}


	createCodeScript() {
		let tmpDiv = jQuery("<div></div>");
		jQuery("body").append(tmpDiv);

		this.codeForInputSets(tmpDiv);
		this.codeForSingleInputs(tmpDiv);
		this.hilightAll();



	}

	codeForInputSets(tmpDiv) {
		let sis = jQuery(".input-set");
		for (let x = 0; x < sis.length; x++) {
			let si = jQuery(sis[x]);
			let complex = si.data("set-type") === "complex" ? true : false;

			let html = si.parent().html();
			//console.log(html)
			tmpDiv.append(html);
			jQuery(".single-input", tmpDiv).remove();
			let comment = jQuery(".comment-set", tmpDiv);
			jQuery(".comment-set", tmpDiv).remove();
			if (complex) {
				jQuery(".js-remove-block", tmpDiv).next().html("<span class=\"§IMPORTANTCOMPLEX§\"></span>");
			} else {
				jQuery(".input-set", tmpDiv).append(jQuery("<span class=\"§IMPORTANTSIMPLE§\"></span>"));
			}

			html = tmpDiv.html();
			html = Pqp.safeReplace(html, "\t", "  ");
			html = this.splitSpecialAttributes(html, false, x)
			html = html.replace(/<!--[\s\S]*?-->/g, "");
			html = this.trimLines(html);
			tmpDiv.html("");



			let tag = jQuery("<pre class='js-pre-set'></pre>");
			let code = jQuery("<code class='language-html' style='margin-bottom:1rem'></code>");
			//console.log();

			code.text(html)
			tag.append(code);

			si.parent().prepend(tag);
			si.parent().prepend(comment);
			comment.removeClass("comment-set");
			comment.addClass("comment");
			comment.css("margin-bottom", "1rem")

			let div = jQuery("<div class='toggle-help-set'></div>");
			let updDown;
			if (complex) {
				updDown = jQuery("<span class='arrow-help js-arrow-help js-toggle-help-set'>&#8593; COMPLEX SET</span>");
			} else {
				updDown = jQuery("<span class='arrow-help js-arrow-help js-toggle-help-set'>&#8593; SIMPLE SET</span>");
			}
			div.prepend(updDown);

			si.parent().prepend(div);
			let cont = jQuery("<div class='container-help-set js-container-help-set'></div>");
			div.append(cont);
			cont.append(si)
			cont.prepend(tag)
			cont.prepend(comment)
			jQuery("pre", cont).hide();

		}

	}


	codeForSingleInputs(tmpDiv) {
		let sis = jQuery(".single-input");
		for (let x = 0; x < sis.length; x++) {
			let si = jQuery(sis[x]);

			let html = si.parent().html();
			tmpDiv.append(html);
			let comment = jQuery(".comment-input", tmpDiv);
			jQuery(".comment-input", tmpDiv).remove();
			jQuery(".comment-set", tmpDiv).remove();
			jQuery(".js-error-txt", tmpDiv).remove();

			if (si.data("fld-type") === "nlsinput") {
				let input = jQuery(jQuery("input", tmpDiv).get(0)).clone();
				input.removeAttr("data-fld-locale");
				jQuery("input", tmpDiv).remove();
				jQuery(".js-input-area-nls", tmpDiv).append(input);
			}

			if (si.data("fld-type") === "nlstextarea") {
				let input = jQuery(jQuery("textarea", tmpDiv).get(0)).clone();
				input.removeAttr("data-fld-locale");
				jQuery("textarea", tmpDiv).remove();
				jQuery(".js-input-area-nls", tmpDiv).append(input);
			}



			html = tmpDiv.html();
			html = Pqp.safeReplace(html, "\t", "  ");
			html = this.splitSpecialAttributes(html, true, x)
			html = html.replace(/<!--[\s\S]*?-->/g, "");
			html = this.trimLines(html);
			tmpDiv.html("");


			let tag = jQuery("<pre></pre>");
			let code = jQuery("<code class='language-html' style='margin-bottom:1rem'></code>");
			//console.log();

			code.text(html)
			tag.append(code);

			si.parent().prepend(tag);
			si.parent().prepend(comment);
			comment.removeClass("comment-input");
			comment.addClass("comment");
			comment.css("margin-bottom", "1rem")

			let div = jQuery("<div class='toggle-help-input'></div>");
			let bt = jQuery("<span class='arrow-help-input js-arrow-help js-toggle-help-input'>&#8593; SINGLE INPUT: " + si.data("fld-name") + "</span>");
			si.parent().prepend(div);
			div.append(bt)
			let cont = jQuery("<div class='container-help-input js-container-help-input'></div>");
			div.append(cont);
			cont.append(si)
			cont.prepend(tag)
			cont.prepend(comment)
			jQuery("pre", cont).hide();



		}

	}

	hilightAll() {
		hljs.highlightAll();

		let a = jQuery(".hljs-attr");
		for (let x = 0; x < a.length; x++) {
			if (jQuery(a[x]).text().startsWith("data-set")) {
				jQuery(a[x]).addClass("data-set-class");
			}
			if (jQuery(a[x]).text().startsWith("data-fld")) {
				jQuery(a[x]).addClass("data-fld-class");
			}
		}
		a = jQuery(".hljs-string");
		for (let x = 0; x < a.length; x++) {
			if (jQuery(a[x]).text().startsWith("\"§IMPORTANTCOMPLEX")) {
				jQuery(a[x]).parent().next().remove();
				jQuery(a[x]).parent().html("<span class='important-reference'>-SINGLE INPUTS HERE-</span>")
			}
			if (jQuery(a[x]).text().startsWith("\"§IMPORTANTSIMPLE")) {
				//jQuery(a[x]).parent().next().remove();
				//jQuery(a[x]).parent().html("  <span class='important-reference'>-SINGLE INPUT HERE-</span>\n  ")
				jQuery(a[x]).parent().html("  <span class='important-reference'>-SINGLE INPUT HERE-</span>\n  ")
			}

		}

		jQuery(".comment-set").remove();
		jQuery(".comment-input").remove();

		setTimeout(this.initClickHelp.bind(this), 500)

	}

	initClickHelp() {
		jQuery(".js-toggle-help-set").off("click");
		jQuery(".js-toggle-help-set").on("click", this.toggleHelpSet.bind(this));
		jQuery(".js-toggle-help-input").off("click");
		jQuery(".js-toggle-help-input").on("click", this.toggleHelpInput.bind(this));
	}


	toggleHelpSet(e) {
		let el = jQuery(".js-pre-set", jQuery(".js-container-help-set", jQuery(e.target).parent()));
		if (el.is(":visible")) {
			this.setHelpArrow(e.target, true);
			el.slideUp();
		} else {
			this.setHelpArrow(e.target, false);
			el.slideDown();
		}
	}

	toggleHelpInput(e) {
		let el = jQuery("pre", jQuery(".js-container-help-input", jQuery(e.target).parent()));
		if (el.is(":visible")) {
			this.setHelpArrow(e.target, true);
			el.slideUp();
		} else {
			this.setHelpArrow(e.target, false);
			el.slideDown();
		}
	}

	setHelpArrow(trg, up) {
		let txt = jQuery(trg).text();
		let tmp = txt.split(" ");
		if (up) {
			txt = "&#8593; "
		} else {
			txt = "&#8595; "
		}
		for (let x = 1; x < tmp.length; x++) {
			txt += tmp[x] + " "
		}


		jQuery(trg).html(txt);
	}

	splitSpecialAttributes(s, lSingleInput, row) {
		//console.log(s)
		let tmp = s.split("<div class=\"single-input\"");
		if (!lSingleInput) {
			tmp = s.split("<div class=\"input-set\"");
		}
		let spaces = ""
		for (let x = tmp[0].length - 1; x >= 0; x--) {
			if (tmp[0].charAt(x) === " ") {
				spaces += " "
			} else {
				break;
			}
		}
		spaces += " "

		let ret;
		if (lSingleInput) {
			ret = Pqp.safeReplace(s, "data-fld-", "\n" + spaces + "data-fld-");
		} else {
			ret = Pqp.safeReplace(s, "data-set-", "\n" + spaces + "data-set-");
		}
		return ret;

	}

	trimLines(html) {
		let ret = "";
		html = Pqp.safeReplace(html, "\r\n", "\n");
		let tmp = html.split("\n");
		let spaces = "";

		let cmp = new Array();
		for (let x = 0; x < tmp.length; x++) {
			if (tmp[x] !== "") {
				cmp.push(tmp[x]);
			}
		}
		tmp = cmp;


		for (let x = 0; x < tmp[0].length; x++) {
			if (tmp[0].charAt(x) === " ") {
				spaces += " "
			} else {
				break;
			}
		}
		//console.log(spaces.length)
		spaces = spaces.substr(2);

		for (let x = 0; x < tmp.length; x++) {
			let content = Pqp.safeReplace(tmp[x], spaces, "");
			if (jQuery.trim(content) !== "") {
				ret += content + "\n";
			}
		}
		return ret;
	}

}



PageDetail.STATE_READ = "r";
PageDetail.STATE_CREATE = "c";
PageDetail.STATE_UPDATE = "u";
PageDetail.STATE_ERROR = "e";

PageDetail.SET_SIMPLE = "simple";
PageDetail.SET_COMPLEX = "complex";

// Tipi di single input (da completare)
PageDetail.TYPE_INPUT = "input";
PageDetail.TYPE_INPUT_EMAIL = "email";
PageDetail.TYPE_INPUT_NUMERIC = "numeric";
PageDetail.TYPE_INPUT_FLOAT = "float";
PageDetail.TYPE_CHECKBOX = "checkbox";
PageDetail.TYPE_SELECT = "select";
PageDetail.TYPE_UPLOAD = "upload";
PageDetail.TYPE_LIST = "list";
PageDetail.TYPE_TEXTAREA = "textarea";
PageDetail.TYPE_NLSINPUT = "nlsinput";
PageDetail.TYPE_NLSTEXTAREA = "nlstextarea";

PageDetail.MANDATORY_TEXT = "This field is mandatory";
PageDetail.MANDATORY_TEXT_LIST = "At least one entry is mandatory";
PageDetail.MANDATORY_TEXT_LIST_MIN = "At least {{0}} entries are mandatory";
PageDetail.VALIDATION_ERROR_TEXT = "Validation error!";
PageDetail.GENERIC_SAVE_ERROR = "Si è verificato un errore durante il salvataggio!";


function setCurrency(currency) {
	if (!currency.id) { return currency.text; }
	var $currency = $('<span class="glyphicon glyphicon-' + currency.element.value + '">' + currency.text + '</span>');
	return $currency;
};
